"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1086],{

/***/ 89444:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dq": () => (/* binding */ TravellerCountWigetStyle),
/* harmony export */   "EY": () => (/* binding */ AgeRangeSectionWrap),
/* harmony export */   "Eo": () => (/* binding */ AgeSelectItem),
/* harmony export */   "I3": () => (/* binding */ TravellerAgeRangePickerWrap),
/* harmony export */   "Jp": () => (/* binding */ TravelDateWigetStyle),
/* harmony export */   "Mf": () => (/* binding */ TravellerCountWigetShimmerStyle),
/* harmony export */   "N": () => (/* binding */ ChevStateWrap),
/* harmony export */   "Ov": () => (/* binding */ AgeRangeSelectSection),
/* harmony export */   "Q6": () => (/* binding */ ApplyCtaSectionWrap),
/* harmony export */   "QT": () => (/* binding */ BookingForName),
/* harmony export */   "UZ": () => (/* binding */ BookingForMail),
/* harmony export */   "ZN": () => (/* binding */ CounterBtn),
/* harmony export */   "ZP": () => (/* binding */ DateSeparator),
/* harmony export */   "aS": () => (/* binding */ TravellerAgenCountHeading),
/* harmony export */   "b1": () => (/* binding */ TravellerCounterDropdown),
/* harmony export */   "bF": () => (/* binding */ TravellingToWidgetStyle),
/* harmony export */   "fF": () => (/* binding */ TravelDateWigetShimmerStyle),
/* harmony export */   "i0": () => (/* binding */ TravellerCounterComboBox),
/* harmony export */   "iC": () => (/* binding */ TravellerCounterDropdownItem),
/* harmony export */   "lJ": () => (/* binding */ TravellerAgeRangeSelectSection),
/* harmony export */   "qX": () => (/* binding */ UpsideDownTriangle),
/* harmony export */   "qb": () => (/* binding */ AgeRangeSelectMobileWrap),
/* harmony export */   "sq": () => (/* binding */ TravellerBookingForComboBox),
/* harmony export */   "t3": () => (/* binding */ AgeRangeSelect),
/* harmony export */   "tB": () => (/* binding */ CountSectionWrap),
/* harmony export */   "v7": () => (/* binding */ RangePickerContentWrap),
/* harmony export */   "vg": () => (/* binding */ CounterWrap)
/* harmony export */ });
/* unused harmony exports TravelPurposeWigetStyle, WidgetList, ListItem, EmptySpace, ChevWrap, BtnWrap, TravellerText */
/* harmony import */ var _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84576);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82740);
/* harmony import */ var _CommonModalDweb_CommonModalDweb_style__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39881);
/* harmony import */ var _TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93139);
/* harmony import */ var _Toast_Toast_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67929);






const TravellingToWidgetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellingToWidgetStyle",
  componentId: "sc-56hbau-0"
})(["display:flex;margin-bottom:24px;position:relative;@media ", "{flex-direction:column;", "{height:300px;}}", "{position:absolute;top:-20px;left:-20px;background:#005756;bottom:auto;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, _CommonModalDweb_CommonModalDweb_style__WEBPACK_IMPORTED_MODULE_3__/* .CommonModalDwebStyle */ .E5, _Toast_Toast_style__WEBPACK_IMPORTED_MODULE_5__/* .ToastStyle */ .jf);
const TravelPurposeWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelPurposeWigetStyle",
  componentId: "sc-56hbau-1"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;flex:2;cursor:pointer;position:relative;border-left:none;"]);
const TravellerCountWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetStyle",
  componentId: "sc-56hbau-2"
})(["background:#ffffff;border:1px solid #e7e7e7;padding:8px 16px;flex:1.1;position:relative;display:flex;justify-content:space-between;gap:8px;align-items:center;@media ", "{border-radius:0 0 8px 8px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const TravellerCountWigetShimmerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(TravellerCountWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCountWigetShimmerStyle",
  componentId: "sc-56hbau-3"
})(["display:flex;gap:20px;align-items:end;"]);
const TravelDateWigetStyle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetStyle",
  componentId: "sc-56hbau-4"
})(["padding:8px 16px;background:#ffffff;border:1px solid #e7e7e7;border-right:none;flex:1;cursor:pointer;position:relative;@media ", "{border-right:1px solid #e7e7e7;border-bottom:none;border-radius:8px 8px 0 0;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const TravelDateWigetShimmerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(TravelDateWigetStyle).withConfig({
  displayName: "TravellingToWidgetstyle__TravelDateWigetShimmerStyle",
  componentId: "sc-56hbau-5"
})(["display:flex;gap:20px;align-items:end;"]);
/* istanbul ignore next */

const WidgetList = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__WidgetList",
  componentId: "sc-56hbau-6"
})(["background:#ffffff;box-shadow:0px 1px 6px rgba(0,0,0,0.2);border-radius:6px;width:", ";height:213px;overflow-y:scroll;position:absolute;top:30px;right:0;z-index:1;", ""], p => p.width ? p.width : "111px", p => p.travelCount && `
left:250px;
`);
const ListItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ListItem",
  componentId: "sc-56hbau-7"
})(["padding:8px 16px;border-bottom:1px solid #ebebeb;cursor:pointer;display:flex;align-items:center;", " @media ", "{padding:12px 24px;display:flex;align-items:center;justify-content:center;&:last-child{margin-bottom:60px;}}"], p => p.selected && `
    ${_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_4__/* .SpanTagStyle */ .zs}{
        color:#008CFF;
        font-weight:700;
    }
    `, _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const EmptySpace = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__EmptySpace",
  componentId: "sc-56hbau-8"
})(["width:100%;height:60px;padding:18px;"]);
const ChevWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevWrap",
  componentId: "sc-56hbau-9"
})(["margin-left:auto;"]);
const DateSeparator = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_TextStyles_TextStyles_style__WEBPACK_IMPORTED_MODULE_4__/* .SpanTagStyle */ .zs).withConfig({
  displayName: "TravellingToWidgetstyle__DateSeparator",
  componentId: "sc-56hbau-10"
})(["flex-shrink:0;"]);
const ChevStateWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ChevStateWrap",
  componentId: "sc-56hbau-11"
})(["cursor:pointer;transition:0.5s ease-in;", ""], p => p.open && `
transform:rotate(180deg);
`);
const BtnWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__BtnWrap",
  componentId: "sc-56hbau-12"
})(["background:var(--base-white,#fff);box-shadow:0px -1px 8px 0px rgba(0,0,0,0.25);padding:16px;position:fixed;bottom:0;left:0px;right:0px;"]);
const CounterWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__CounterWrap",
  componentId: "sc-56hbau-13"
})(["border-radius:", ";background:#fff;box-shadow:", ";padding:", ";display:flex;gap:", ";", ";align-items:center;width:fit-content;height:", ";button{background:transparent;cursor:pointer;display:flex;padding:0;}span{word-break:unset;}"], prop => prop.borderRadius ? prop.borderRadius : "4px", prop => prop.boxShadow ? prop.boxShadow : "0px 0px 6px 0px rgba(0, 0, 0, 0.2)", prop => prop.padding ? prop.padding : "0px 8px", prop => prop.gap ? prop.gap : "14px", prop => prop.border ? `border:${prop.border}` : "", prop => prop.height ? prop.height : "40px");
const CounterBtn = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "TravellingToWidgetstyle__CounterBtn",
  componentId: "sc-56hbau-14"
})(["", ""], p => p.isDiabled && `
pointer-events:none;
opacity:0.5;
`);
const mobileAnim = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]); //here I am

const TravellerAgeRangePickerWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerAgeRangePickerWrap",
  componentId: "sc-56hbau-15"
})(["width:393px;background:#ffffff;box-sizing:border-box;box-shadow:0px 1px 6px 0px #00000033;display:flex;flex-direction:column;z-index:1;border-radius:4px;position:absolute;@media ", "{right:24px;top:6px;}@media ", "{width:100%;position:fixed;left:0;flex-direction:column;", " border-radius:16px 16px 0 0;box-sizing:border-box;width:100%;position:fixed;left:0;bottom:-100%;z-index:10;background-color:#fff;animation-fill-mode:forwards;animation:", " 0.3s ease-in-out;animation-fill-mode:forwards;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.desktop */ .vO.desktop, _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, p => p.isBottomSheetFullScreen && `height: 100vh;`, mobileAnim);
const TravellerAgeRangeSelectSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerAgeRangeSelectSection",
  componentId: "sc-56hbau-16"
})(["display:grid;grid-template-columns:1fr 1fr;@media ", "{grid-template-columns:1fr;}gap:8px;"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const AgeRangeSelectSection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeRangeSelectSection",
  componentId: "sc-56hbau-17"
})(["display:flex;padding:8px 7px;background:#fff;border:1px solid #d8d8d8;border-radius:8px;gap:14px;z-index:3;align-items:center;width:99px;height:32px;@media ", "{position:relative;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const CountSectionWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__CountSectionWrap",
  componentId: "sc-56hbau-18"
})(["display:flex;flex-direction:column;gap:16px;@media ", "{z-index:-1;position:relative;}padding-bottom:16px;"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const AgeRangeSectionWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeRangeSectionWrap",
  componentId: "sc-56hbau-19"
})(["display:flex;padding-top:16px;flex-direction:column;gap:16px;@media ", "{max-height:220px;visibility:visible;position:relative;overflow-y:auto;}@media ", "{z-index:-1;position:relative;overflow-y:scroll;overflow-x:hidden;", "}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.desktop */ .vO.desktop, _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, p => p.isBottomSheetFullScreen ? `flex-grow: 1;
    margin-bottom: 145px;
    ` : ` max-height: 300px;`);
const ApplyCtaSectionWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__ApplyCtaSectionWrap",
  componentId: "sc-56hbau-20"
})(["display:flex;justify-content:flex-end;gap:10px;padding 19px;box-shadow:0px 1px 6px 0px #00000033;@media ", "{z-index:1000;position:fixed;bottom:0;left:0;right:0;background:#fff;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const AgeRangeSelectMobileWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeRangeSelectMobileWrap",
  componentId: "sc-56hbau-21"
})(["display:flex;flex-direction:column;max-height:143px;position:fixed;align-items:center;justify-content:center;z-index:1000;left:", "px;bottom:", "px;"], p => p.left && p.left, p => p.bottom && p.bottom);
const AgeRangeSelect = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeRangeSelect",
  componentId: "sc-56hbau-22"
})(["display:flex;align-items:center;flex-direction:column;background:#fff;border:1px solid #d8d8d8;border-radius:8px;@media ", "{z-index:100;position:fixed;", ";", ";}@media ", "{box-shadow:0px 1px 7px 0px #00000033;}overflow-y:scroll;max-height:134px;"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.desktop */ .vO.desktop, p => p.top && `top:${p.top}px`, p => p.left && `left:${p.left}px`, _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const AgeSelectItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__AgeSelectItem",
  componentId: "sc-56hbau-23"
})(["padding:1px 25.4px;width:100%;position:relative;background:#fff;cursor:pointer;&:hover{background:#eaf5ff;span{color:#008cff;}}"]);
const RangePickerContentWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__RangePickerContentWrap",
  componentId: "sc-56hbau-24"
})(["padding:22px;@media ", "{z-index:-1;position:relative;margin-bottom:70px;", "}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile, p => p.isBottomSheetFullScreen && `display: flex;
    flex-direction: column;
    height: 100vh;`);
const UpsideDownTriangle = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__UpsideDownTriangle",
  componentId: "sc-56hbau-25"
})(["width:0;height:0;border-left:6.1px solid transparent;border-right:6.1px solid transparent;border-top:9px solid #fff;filter:drop-shadow(0px 1px 7px #00000033);"]);
const TravellerAgenCountHeading = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerAgenCountHeading",
  componentId: "sc-56hbau-26"
})(["display:flex;align-items:center;gap:8px;margin:24px 0px 0px 0px;padding:11px 16px;border-bottom:1px solid #d8d8d8;"]);
const TravellerCounterComboBox = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCounterComboBox",
  componentId: "sc-56hbau-27"
})(["background:#ffffff;border:1px solid #e7e7e7;padding:8px 16px;position:relative;cursor:pointer;@media ", "{border-radius:0 0 8px 8px;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const TravellerBookingForComboBox = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerBookingForComboBox",
  componentId: "sc-56hbau-28"
})(["background:#ffffff;border:1px solid #e7e7e7;padding:8px 16px;position:relative;width:29%;@media ", "{margin-top:8px;border-radius:8px;width:100%;}"], _tm_static_utils__WEBPACK_IMPORTED_MODULE_0__/* .deviceType.mobile */ .vO.mobile);
const TravellerText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerText",
  componentId: "sc-56hbau-29"
})(["font-family:Lato;font-weight:400;font-size:22px;line-height:100%;letter-spacing:0%;margin-left:4px;"]);
const BookingForName = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravellingToWidgetstyle__BookingForName",
  componentId: "sc-56hbau-30"
})(["display:inline-block;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:900;"]);
const BookingForMail = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TravellingToWidgetstyle__BookingForMail",
  componentId: "sc-56hbau-31"
})(["display:inline-block;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:12px;line-height:16px;font-weight:400;color:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_1__/* .theme.greyText6 */ .rS.greyText6);
const TravellerCounterDropdown = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCounterDropdown",
  componentId: "sc-56hbau-32"
})(["position:absolute;top:100%;left:0;z-index:1000;background:#fff;border:1px solid #e0e0e0;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,0.08);width:100%;max-height:240px;overflow-y:auto;"]);
const TravellerCounterDropdownItem = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TravellingToWidgetstyle__TravellerCounterDropdownItem",
  componentId: "sc-56hbau-33"
})(["padding:8px 16px;cursor:pointer;background:", ";font-weight:", ";&:hover{background:#f0f0f0;}"], ({
  selected
}) => selected ? "#f5f5f5" : "#fff", ({
  selected
}) => selected ? 600 : 400);

/***/ }),

/***/ 16638:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _TravellingToWidget_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89444);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98790);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52322);






const TravellingToWidgetShimmer = ({}) => {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_TravellingToWidget_style__WEBPACK_IMPORTED_MODULE_1__/* .TravellingToWidgetStyle */ .bF, {
    "data-test-id": "TravellingToWidgetShimmer-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_TravellingToWidget_style__WEBPACK_IMPORTED_MODULE_1__/* .TravelDateWigetShimmerStyle */ .fF, {
      "data-test-id": "TravellingToWidgetShimmer-TravelDateWigetShimmerStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FlexComp, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ShimmerVersion2, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ShimmerVersion2, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ShimmerVersion2, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_TravellingToWidget_style__WEBPACK_IMPORTED_MODULE_1__/* .TravellerCountWigetShimmerStyle */ .Mf, {
      "data-test-id": "TravellingToWidgetShimmer-TravellerCountWigetShimmerStyle",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.FlexComp, {
        flexDirection: "column",
        gap: "4px",
        "data-test-id": "TravellingToWidgetShimmer-FlexComp",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ShimmerVersion2, {
          width: "76px",
          height: "16px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ShimmerVersion2, {
          width: "76px",
          height: "38px",
          "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_2__.ShimmerVersion2, {
        width: "76px",
        height: "38px",
        "data-test-id": "TravellingToWidgetShimmer-ShimmerVersion2"
      })]
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TravellingToWidgetShimmer);

/***/ }),

/***/ 2450:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ WhatsCovered_WhatsCovered)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 10 modules
var components = __webpack_require__(98790);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(20984);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.style.ts
var FlexComp_style = __webpack_require__(88025);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhatsCovered/WhatsCovered.style.ts






const WhatsCoveredStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhatsCoveredstyle__WhatsCoveredStyle",
  componentId: "sc-1tsmpyu-0"
})(["background:#fff;width:100%;", "{font-weight:900;}", " @media ", "{padding:0 16px;", "{> ", "{overflow-y:auto;-webkit-overflow-scrolling:touch;margin-right:-16px;margin-left:-16px;padding-left:16px;padding-right:16px;}}}"], TextStyles_style/* H2TagStyle */.FI, p => p.theme.pageTheme === isomorphic_utils_src.PARTNER.MMT && `
    ${TextStyles_style/* H4TagStyle */.sz}{
        font-size:24px;
        font-weight:900;
    }
    `, utils/* deviceType.mobile */.vO.mobile, CommonStyles_style/* InnerContentWrap */.I, FlexComp_style/* FlexCompStyle */.l);
const BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhatsCoveredstyle__BenefitItem",
  componentId: "sc-1tsmpyu-1"
})(["flex:1;@media ", "{width:230px;flex-shrink:0;flex:none;}"], utils/* deviceType.mobile */.vO.mobile);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhatsCovered/WhatsCovered.tsx













const WhatsCovered = ({
  data,
  title,
  info
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    (0,XDMAnalytics.trackComponentView)({
      name: "section_3_shown",
      type: "card"
    });

    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "whats_covered_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: intersectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhatsCoveredStyle, {
    ref: intersectionRef,
    "data-test-id": "WhatsCovered-WhatsCoveredStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "WhatsCovered-InnerContentWrap",
      children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
        "data-test-id": "WhatsCovered-H2Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components.H5Tag, {
        "data-test-id": "WhatsCovered-H5Tag",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: title,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
        fontSize: device == "lg" ? "large" : "sm",
        color: Global/* theme.greyText */.rS.greyText,
        margin: "0 0 66px",
        "data-test-id": "WhatsCovered-ParaTag",
        children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: info,
          "data-test-id": "WhatsCovered-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.FlexComp, {
        gap: device == "lg" ? data?.length === 2 ? "50px" : "82px" : "24px",
        "data-test-id": "WhatsCovered-FlexComp",
        children: data && data.map((item, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(BenefitItem, {
            "data-test-id": `WhatsCovered-BenefitItem-${index}`,
            children: [item.cardImg && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
              width: device == "lg" ? "164px" : "80px",
              height: device == "lg" ? "164px" : "80px",
              src: item.cardImg,
              "data-test-id": "WhatsCovered-ImageComponent"
            }), device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H4Tag, {
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-H4Tag",
              children: item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components.ParaTag, {
              fontSize: "large",
              fontWeight: "black",
              margin: "0 0 8px",
              "data-test-id": "WhatsCovered-ParaTag",
              children: [" ", item.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: item.title,
                "data-test-id": "WhatsCovered-FormattedText"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
              fontSize: device == "lg" ? "large" : "sm",
              color: device == "lg" ? Global/* theme.greyText7 */.rS.greyText7 : Global/* theme.blackText */.rS.blackText,
              "data-test-id": "WhatsCovered-ParaTag",
              children: item.info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: item.info,
                "data-test-id": "WhatsCovered-FormattedText"
              })
            })]
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ const WhatsCovered_WhatsCovered = (WhatsCovered);

/***/ }),

/***/ 53797:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ WhyBuySection_WhyBuySection)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhyBuySection/WhyBuySection.style.ts


const WhyBuySectionStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhyBuySectionstyle__WhyBuySectionStyle",
  componentId: "v4rvdb-0"
})(["display:flex;flex-direction:column;background-color:", ";margin:0 auto;width:1200px;border-radius:16px;padding:40px;gap:32px;"], Global/* theme.whiteText */.rS.whiteText);
const WhyBuySectionTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "WhyBuySectionstyle__WhyBuySectionTitle",
  componentId: "v4rvdb-1"
})(["color:", ";font-weight:900;font-size:32px;"], Global/* theme.blackText */.rS.blackText);
const WhyBuySectionDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "WhyBuySectionstyle__WhyBuySectionDescription",
  componentId: "v4rvdb-2"
})(["font-weight:400;color:", ";font-size:16px;width:80%;"], Global/* theme.greyText */.rS.greyText);
const WhyBuySectionCustomNumbers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhyBuySectionstyle__WhyBuySectionCustomNumbers",
  componentId: "v4rvdb-3"
})(["display:flex;align-items:flex-start;justify-content:space-between;"]);
const WhyBuySectionCustomNumber = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhyBuySectionstyle__WhyBuySectionCustomNumber",
  componentId: "v4rvdb-4"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:8px;width:175px;"]);
const WhyBuySectionCustomNumberTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "WhyBuySectionstyle__WhyBuySectionCustomNumberTitle",
  componentId: "v4rvdb-5"
})(["font-weight:900;font-size:32px;"]);
const WhyBuySectionCustomNumberInfo = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "WhyBuySectionstyle__WhyBuySectionCustomNumberInfo",
  componentId: "v4rvdb-6"
})(["color:", ";font-weight:400;font-size:16px;"], Global/* theme.greyText */.rS.greyText);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhyBuySection/WhyBuySection.tsx








const WhyBuySection = ({
  whyBuySectionData
}) => {
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "why_buy_section_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: whyBuySectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(WhyBuySectionStyle, {
    ref: whyBuySectionRef,
    "data-test-id": "WhyBuySection-WhyBuySectionStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuySectionTitle, {
      "data-test-id": "WhyBuySection-WhyBuySectionTitle",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: whyBuySectionData.title,
        "data-test-id": "WhyBuySection-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuySectionDescription, {
      "data-test-id": "WhyBuySection-WhyBuySectionDescription",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: whyBuySectionData.description,
        "data-test-id": "WhyBuySection-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuySectionCustomNumbers, {
      "data-test-id": "WhyBuySection-WhyBuySectionCustomNumbers",
      children: whyBuySectionData.customNumbers.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(WhyBuySectionCustomNumber, {
        "data-test-id": `WhyBuySection-WhyBuySectionCustomNumber-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuySectionCustomNumberTitle, {
          "data-test-id": "WhyBuySection-WhyBuySectionCustomNumberTitle",
          children: item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuySectionCustomNumberInfo, {
          "data-test-id": "WhyBuySection-WhyBuySectionCustomNumberInfo",
          children: item.info
        })]
      }, index))
    })]
  });
};

/* harmony default export */ const WhyBuySection_WhyBuySection = (WhyBuySection);

/***/ }),

/***/ 62107:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ WhyBuyTravIns_WhyBuyTravIns)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 10 modules
var components = __webpack_require__(98790);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/CommonStyle/CommonStyles.style.ts
var CommonStyles_style = __webpack_require__(20984);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhyBuyTravIns/WhyBuyTravIns.style.ts




const WhyBuyTravInsStyle = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyTravInsStyle",
  componentId: "sc-1sprh6s-0"
})(["background:", ";width:100%;z-index:1;", " ", "{width:510px;@media ", "{width:100%;}}@media ", "{padding:0 16px;", "}"], p => p.theme.pageTheme === src.PARTNER.MYBIZ ? `none` : `#fff`, p => p.theme.pageTheme === src.PARTNER.GI && `
    background: #EFF3F8;
    padding-bottom:80px;
    `, TextStyles_style/* H2TagStyle */.FI, utils/* deviceType.mobile */.vO.mobile, utils/* deviceType.mobile */.vO.mobile, p => p.theme.pageTheme === src.PARTNER.GI && `
    background: #fff;
    padding-top:16px;
    `);
const WhyFeatListWrap = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyFeatListWrap",
  componentId: "sc-1sprh6s-1"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:16px;flex-shrink:0;@media ", "{width:100%;grid-template-columns:repeat(1,1fr);}img{margin-top:4px;}"], utils/* deviceType.mobile */.vO.mobile);
const WhyBuyItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "WhyBuyTravInsstyle__WhyBuyItem",
  componentId: "sc-1sprh6s-2"
})(["display:flex;gap:8px;padding:16px;background:#ffffff;border:1px solid #ececec;box-shadow:0px 3px 12px rgba(0,0,0,0.2);border-radius:10px;width:300px;flex-shrink:0;font-size:18px;line-height:25px;svg{flex-shrink:0;}@media ", "{width:100%;box-shadow:none;}"], utils/* deviceType.mobile */.vO.mobile);
const ShieldWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "WhyBuyTravInsstyle__ShieldWrap",
  componentId: "sc-1sprh6s-3"
})(["position:absolute;right:-60px;z-index:-1;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/WhyBuyTravIns/WhyBuyTravIns.tsx















const WhyBuyTravIns = ({
  title,
  info,
  data
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    (0,XDMAnalytics.trackComponentView)({
      name: "section_1_shown",
      type: "card"
    });

    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "why_buy_trav_ins_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: intersectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    // triggerOnce: true, // Only track once per component mount
    triggerOnLeaveViewport: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WhyBuyTravInsStyle, {
    ref: intersectionRef,
    "data-test-id": "WhyBuyTravIns-WhyBuyTravInsStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CommonStyles_style/* InnerContentWrap */.I, {
      "data-test-id": "WhyBuyTravIns-InnerContentWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp // flexWrap="wrap"
      , {
        flexDirection: device == "lg" ? "row" : "column",
        alignItems: "center",
        gap: device == "lg" ? context === src.PARTNER.MYBIZ ? "10px" : "74px" : "24px",
        "data-test-id": "WhyBuyTravIns-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(components.H2Tag, {
            margin: "0 0 60px",
            "data-test-id": "WhyBuyTravIns-H2Tag",
            children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(components.H5Tag, {
            margin: "0 0 20px",
            "data-test-id": "WhyBuyTravIns-H5Tag",
            children: [" ", title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: title,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
            fontSize: device == "lg" ? "large" : "sm",
            color: Global/* theme.greyText */.rS.greyText,
            "data-test-id": "WhyBuyTravIns-ParaTag",
            children: info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: info,
              "data-test-id": "WhyBuyTravIns-FormattedText"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyFeatListWrap, {
          "data-test-id": "WhyBuyTravIns-WhyFeatListWrap",
          children: data && data.map((item, index) => {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(WhyBuyItem, {
              "data-test-id": `WhyBuyTravIns-WhyBuyItem-${index}`,
              children: [item.icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
                src: item.icon,
                height: "24",
                width: "24",
                "data-test-id": "WhyBuyTravIns-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
                "data-test-id": "WhyBuyTravIns-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                  value: item?.info,
                  "data-test-id": "WhyBuyTravIns-FormattedText"
                })
              })]
            }, index);
          })
        }), device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(ShieldWrap, {
          "data-test-id": "WhyBuyTravIns-ShieldWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ImageComponent, {
            width: "286px",
            height: "320px",
            src: "https://tripmoneycmsimgak.mmtcdn.com/img/Light_Green_Shield_5cb1aff4ce.svg",
            "data-test-id": "WhyBuyTravIns-ImageComponent"
          })
        })]
      })
    })
  });
};

/* harmony default export */ const WhyBuyTravIns_WhyBuyTravIns = (WhyBuyTravIns);

/***/ }),

/***/ 98790:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AddAlternateContact": () => (/* reexport */ AddAlternateContact/* default */.Z),
  "AddPassportDetail": () => (/* reexport */ AddPassportDetail/* default */.Z),
  "AddPassportModal": () => (/* reexport */ AddPassportModal/* default */.Z),
  "AddTravellerDetailShimmer": () => (/* reexport */ AddTravellerDetailShimmer/* default */.Z),
  "AddTravellerDetails": () => (/* reexport */ AddTravellerDetails/* default */.Z),
  "AddTravellerDetailsComp": () => (/* reexport */ AddTravellerDetailsComp/* default */.Z),
  "AgentAgreementModal": () => (/* reexport */ AgentAgreementModal/* default */.Z),
  "AnchorTag": () => (/* reexport */ AnchorTag/* default */.Z),
  "BackDropComp": () => (/* reexport */ BackDropComp/* default */.Z),
  "BenefitItem": () => (/* reexport */ BenefitItem/* default */.Z),
  "BottomBar": () => (/* reexport */ BottomBar["default"]),
  "BreadcrumbComponent": () => (/* reexport */ BreadcrumbComponent/* default */.Z),
  "BulletListItem": () => (/* reexport */ BulletListItem/* default */.Z),
  "CalendarPersuasionModal": () => (/* reexport */ CalendarPersuasionModal/* default */.Z),
  "CarouselPersuasion": () => (/* reexport */ CarouselPersuasion/* default */.Z),
  "CheckButton": () => (/* reexport */ CheckButton/* default */.Z),
  "ClaimYourInsurance": () => (/* reexport */ ClaimYourInsurance/* default */.Z),
  "CommonLandingBottomComp": () => (/* reexport */ CommonLandingBottomComp/* default */.Z),
  "CommonModalDweb": () => (/* reexport */ CommonModalDweb/* default */.Z),
  "ComparePlan": () => (/* reexport */ ComparePlan/* default */.Z),
  "ContentBlock": () => (/* reexport */ ContentBlock/* default */.Z),
  "CountryCodeInput": () => (/* reexport */ CountryCodeInput/* default */.Z),
  "DatePicker": () => (/* reexport */ DatePickerComp["default"]),
  "DatePickerComp": () => (/* reexport */ DatePickerComp["default"]),
  "DesktopLayout": () => (/* reexport */ DesktopLayout/* default */.Z),
  "DisclaimerComp": () => (/* reexport */ DisclaimerComp/* default */.Z),
  "DnldPolicyComponent": () => (/* reexport */ DnldPolicyComponent/* default */.Z),
  "DomesticTrip": () => (/* reexport */ DomesticTrip/* default */.Z),
  "DropOffModal": () => (/* reexport */ DropOffModal/* default */.Z),
  "EditTraveller": () => (/* reexport */ EditTraveller/* default */.Z),
  "EditTravellerSheet": () => (/* reexport */ EditTravellerSheet/* default */.Z),
  "ExclusiveOffers": () => (/* reexport */ ExclusiveOffers/* default */.Z),
  "FilterBottomComp": () => (/* reexport */ FilterBottomComp/* default */.Z),
  "FilterPlans": () => (/* reexport */ FilterPlans/* default */.Z),
  "FlexComp": () => (/* reexport */ FlexComp/* default */.Z),
  "FooterSectionComp": () => (/* reexport */ FooterSectionComp/* default */.Z),
  "FormattedText": () => (/* reexport */ FormattedText/* default */.Z),
  "GreatChoice": () => (/* reexport */ GreatChoice/* default */.Z),
  "GreatChoiceShimmer": () => (/* reexport */ GreatChoiceShimmer/* default */.Z),
  "H2Tag": () => (/* reexport */ H2Tag/* default */.Z),
  "H3Tag": () => (/* reexport */ H3Tag/* default */.Z),
  "H4Tag": () => (/* reexport */ H4Tag/* default */.Z),
  "H5Tag": () => (/* reexport */ H5Tag/* default */.Z),
  "H6Tag": () => (/* reexport */ H6Tag/* default */.Z),
  "HeaderTitleComp": () => (/* reexport */ HeaderTitleComp/* default */.Z),
  "ImageComponent": () => (/* reexport */ ImageComponent/* ImageComponent */.c),
  "ImageTag": () => (/* reexport */ ImageTag/* default */.Z),
  "InfoModal": () => (/* reexport */ InfoModal/* default */.Z),
  "InsPlanModalCommonInfo": () => (/* reexport */ InsPlanModalCommonInfo/* default */.Z),
  "InsuranceBooked": () => (/* reexport */ InsuranceBooked/* default */.Z),
  "InsuranceBookedShimmer": () => (/* reexport */ InsuranceBookedShimmer/* default */.Z),
  "InsurancePlanTypeSectionComp": () => (/* reexport */ InsurancePlanTypeSection/* default */.Z),
  "InsurancePlans": () => (/* reexport */ InsurancePlans/* default */.Z),
  "InsurancePlansComp": () => (/* reexport */ InsurancePlansComp/* default */.Z),
  "InsurancePlansHeader": () => (/* reexport */ InsurancePlansHeader/* default */.Z),
  "InsuranceStats": () => (/* reexport */ InsuranceStats/* default */.Z),
  "ItineraryInfoComp": () => (/* reexport */ ItineraryInfoComp/* default */.Z),
  "LandingBenefits": () => (/* reexport */ LandingBenefits/* default */.Z),
  "LandingButton": () => (/* reexport */ LandingButton/* default */.Z),
  "LandingButtonComp": () => (/* reexport */ LandingButtonComp/* default */.Z),
  "LandingButtonTertiary": () => (/* reexport */ LandingButtonTertiary/* default */.Z),
  "LandingButtonWhite": () => (/* reexport */ LandingButtonWhite/* default */.Z),
  "LandingFooter": () => (/* reexport */ LandingFooter/* default */.Z),
  "LandingFooterInsurance": () => (/* reexport */ LandingFooterInsurance/* default */.Z),
  "LandingHeader": () => (/* reexport */ LandingHeader/* default */.Z),
  "LandingHeaderMobile": () => (/* reexport */ LandingHeaderMobile/* default */.Z),
  "LandingInput": () => (/* reexport */ LandingInput/* default */.Z),
  "LandingTestimonials": () => (/* reexport */ LandingTestimonials/* default */.Z),
  "ListingEditDetails": () => (/* reexport */ ListingEditDetails/* default */.Z),
  "ListingTravelDetails": () => (/* reexport */ ListingTravelDetails/* default */.Z),
  "ManageInsurance": () => (/* reexport */ ManageInsurance/* default */.Z),
  "ManageInsuranceShimmer": () => (/* reexport */ ManageInsuranceShimmer/* default */.Z),
  "MoreBenefits": () => (/* reexport */ MoreBenefits/* default */.Z),
  "NoInsurancePlan": () => (/* reexport */ NoInsurancePlan/* default */.Z),
  "OfferedBySection": () => (/* reexport */ OfferedBySection/* default */.Z),
  "OffersBenefitsSection": () => (/* reexport */ OffersBenefitsSection/* default */.Z),
  "OrderAmtPaid": () => (/* reexport */ OrderAmtPaid/* default */.Z),
  "OrderDetailInsurance": () => (/* reexport */ OrderDetailInsurance/* default */.Z),
  "OrderDetailPlan": () => (/* reexport */ OrderDetailPlan/* default */.Z),
  "OrderDetailPlanShimmer": () => (/* reexport */ OrderDetailPlanShimmer/* default */.Z),
  "OrderDetailTraveller": () => (/* reexport */ OrderDetailTraveller/* default */.Z),
  "OrderDetails": () => (/* reexport */ OrderDetails/* default */.Z),
  "OrderDetailsShimmer": () => (/* reexport */ OrderDetailsShimmer/* default */.Z),
  "OrderGetHelp": () => (/* reexport */ OrderGetHelp/* default */.Z),
  "OrderInsurance": () => (/* reexport */ OrderInsurance/* default */.Z),
  "OrderListingComp": () => (/* reexport */ OrderListingComp/* default */.Z),
  "OrderPriceBreakup": () => (/* reexport */ OrderPriceBreakup/* default */.Z),
  "OrderStatusComp": () => (/* reexport */ OrderStatusComp/* default */.Z),
  "ParaTag": () => (/* reexport */ ParaTag/* default */.Z),
  "PassportNumComp": () => (/* reexport */ PassportNumComp/* default */.Z),
  "PaymentOfferBreakdown": () => (/* reexport */ PaymentOfferBreakdown/* default */.Z),
  "PaymentStatusComp": () => (/* reexport */ PaymentStatusComp/* default */.Z),
  "PersuasionBanner": () => (/* reexport */ PersuasionBanner/* default */.Z),
  "PersuasionBannerInsurance": () => (/* reexport */ PersuasionBannerInsurance/* default */.Z),
  "PlanCardsList": () => (/* reexport */ PlanCardsList/* default */.Z),
  "PlanPriceInfoComp": () => (/* reexport */ PlanPriceInfoComp/* default */.Z),
  "PoweredBySection": () => (/* reexport */ PoweredBySection/* default */.Z),
  "PriceBreakup": () => (/* reexport */ PriceBreakup/* default */.Z),
  "PrimaryContact": () => (/* reexport */ PrimaryContact/* default */.Z),
  "PrimaryContactComp": () => (/* reexport */ PrimaryContactComp/* default */.Z),
  "RadioButton": () => (/* reexport */ RadioButton/* default */.Z),
  "RangeDatePicker": () => (/* reexport */ RangeDatePicker["default"]),
  "ReactPortalComp": () => (/* reexport */ ReactPortalComp/* default */.Z),
  "RecentSearches": () => (/* reexport */ RecentSearches/* default */.Z),
  "SafenSecureTrav": () => (/* reexport */ SafenSecureTrav/* default */.Z),
  "SectionDividers": () => (/* reexport */ SectionDividers/* default */.Z),
  "SecureTravOffer": () => (/* reexport */ SecureTravOffer/* default */.Z),
  "SelectCountryCodeModal": () => (/* reexport */ SelectCountryCodeModal/* default */.Z),
  "SelectCountryModalSheetV2": () => (/* reexport */ SelectCountryModalSheetV2/* default */.Z),
  "SelectCountryModalV2": () => (/* reexport */ SelectCountryModalV2["default"]),
  "Shimmer": () => (/* reexport */ Shimmer/* default */.Z),
  "ShimmerVersion2": () => (/* reexport */ ShimmerVersion2/* default */.Z),
  "ShimmerVersion3": () => (/* reexport */ ShimmerVersion3/* default */.Z),
  "ShowInsPlan": () => (/* reexport */ ShowInsPlan/* default */.Z),
  "SocialLogos": () => (/* reexport */ SocialLogos/* default */.Z),
  "SpanTag": () => (/* reexport */ SpanTag/* default */.Z),
  "Spinner": () => (/* reexport */ Spinner/* default */.Z),
  "TMFloatingInput": () => (/* reexport */ TMFloatingInput/* default */.Z),
  "Tags": () => (/* reexport */ Tags/* default */.Z),
  "TestComponent": () => (/* reexport */ TestComponent/* default */.Z),
  "TestimonialsSection": () => (/* reexport */ TestimonialsSection/* default */.Z),
  "TickRadioComp": () => (/* reexport */ TickRadioComp/* default */.Z),
  "TmNPSFeedback": () => (/* reexport */ TMNPSFeedback/* default */.Z),
  "TncComp": () => (/* reexport */ TncComp/* default */.Z),
  "Toast": () => (/* reexport */ Toast/* default */.Z),
  "ToastCompare": () => (/* reexport */ ToastCompare/* default */.Z),
  "ToolTipComp": () => (/* reexport */ ToolTipComp/* default */.Z),
  "TravAssistant": () => (/* reexport */ TravAssistant/* default */.Z),
  "TravelAssistanceModal": () => (/* reexport */ TravelAssistanceModal/* default */.Z),
  "TravelProtectionV2": () => (/* reexport */ TravelProtectionV2_TravelProtectionV2),
  "TravellingTo": () => (/* reexport */ TravellingTo/* default */.Z),
  "TravellingToShimmer": () => (/* reexport */ TravellingToShimmer/* default */.Z),
  "TravellingToWidget": () => (/* reexport */ TravellingToWidget_TravellingToWidget),
  "WhatsCovered": () => (/* reexport */ WhatsCovered/* default */.Z),
  "WhyBuyTravIns": () => (/* reexport */ WhyBuyTravIns/* default */.Z)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddAlternateContact/AddAlternateContact.tsx + 1 modules
var AddAlternateContact = __webpack_require__(84938);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddPassportDetail/AddPassportDetail.tsx + 1 modules
var AddPassportDetail = __webpack_require__(99926);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetails.tsx + 1 modules
var AddTravellerDetails = __webpack_require__(22821);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetail/AddTravellerDetailShimmer.tsx + 1 modules
var AddTravellerDetailShimmer = __webpack_require__(88218);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetailsComp/AddTravellerDetailsComp.tsx + 1 modules
var AddTravellerDetailsComp = __webpack_require__(80330);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AgentAgreementModal/AgentAgreementModal.tsx + 1 modules
var AgentAgreementModal = __webpack_require__(60812);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/BackDropComp/BackDropComp.tsx + 1 modules
var BackDropComp = __webpack_require__(13255);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/BottomBar/BottomBar.tsx + 1 modules
var BottomBar = __webpack_require__(16724);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/BreadcrumbComponent/BreadcrumbComponent.tsx + 1 modules
var BreadcrumbComponent = __webpack_require__(17852);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/BulletListItem/BulletListItem.tsx
var BulletListItem = __webpack_require__(50996);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CalendarPersuasionModal/CalendarPersuasionModal.tsx + 1 modules
var CalendarPersuasionModal = __webpack_require__(56869);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CarouselPersuasion/CarouselPersuasion.tsx + 1 modules
var CarouselPersuasion = __webpack_require__(21764);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CheckButton/CheckButton.tsx
var CheckButton = __webpack_require__(97004);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ClaimYourInsurance/ClaimYourInsurance.tsx + 2 modules
var ClaimYourInsurance = __webpack_require__(59219);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonLandingBottomComp/CommonLandingBottomComp.tsx
var CommonLandingBottomComp = __webpack_require__(23111);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.tsx
var CommonModalDweb = __webpack_require__(33270);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ComparePlan/ComparePlan.tsx + 4 modules
var ComparePlan = __webpack_require__(33701);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ContentBlock/ContentBlock.tsx + 1 modules
var ContentBlock = __webpack_require__(67189);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CountryCodeInput/CountryCodeInput.tsx + 1 modules
var CountryCodeInput = __webpack_require__(21864);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DatePickerComp/DatePickerComp.tsx
var DatePickerComp = __webpack_require__(85891);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DesktopLayout/DesktopLayout.tsx + 1 modules
var DesktopLayout = __webpack_require__(97868);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DisclaimerComp/DisclaimerComp.tsx
var DisclaimerComp = __webpack_require__(56081);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DnldPolicyComponent/DnldPolicyComponent.tsx + 1 modules
var DnldPolicyComponent = __webpack_require__(15177);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DomesticTravelDetail/DomesticTrip.tsx + 1 modules
var DomesticTrip = __webpack_require__(26146);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DropOffModal/DropOffModal.tsx + 1 modules
var DropOffModal = __webpack_require__(81291);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/EditTraveller/EditTraveller.tsx
var EditTraveller = __webpack_require__(67678);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/EditTraveller/EditTravellerSheet.tsx
var EditTravellerSheet = __webpack_require__(76801);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ExculsiveOffers/ExclusiveOffers.tsx + 2 modules
var ExclusiveOffers = __webpack_require__(13864);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FilterBottomComp/FilterBottomComp.tsx + 1 modules
var FilterBottomComp = __webpack_require__(55358);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FilterPlans/FilterPlans.tsx + 2 modules
var FilterPlans = __webpack_require__(23618);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FlexComp/FlexComp.tsx
var FlexComp = __webpack_require__(636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FooterSectionComp/FooterSectionComp.tsx + 1 modules
var FooterSectionComp = __webpack_require__(36907);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/GreatChoice/GreatChoice.tsx
var GreatChoice = __webpack_require__(56230);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/GreatChoice/GreatChoiceShimmer.tsx
var GreatChoiceShimmer = __webpack_require__(85443);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/HeaderTitleComp/HeaderTitleComp.tsx
var HeaderTitleComp = __webpack_require__(9309);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageComponent/ImageComponent.tsx
var ImageComponent = __webpack_require__(48608);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ImageTag/ImageTag.tsx
var ImageTag = __webpack_require__(54990);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InfoModal/InfoModal.tsx
var InfoModal = __webpack_require__(68634);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBooked.tsx + 2 modules
var InsuranceBooked = __webpack_require__(72425);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsuranceBooked/InsuranceBookedShimmer.tsx
var InsuranceBookedShimmer = __webpack_require__(73642);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/BenefitItem.tsx
var BenefitItem = __webpack_require__(93626);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsPlanModalCommonInfo.tsx + 3 modules
var InsPlanModalCommonInfo = __webpack_require__(53952);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlans.tsx
var InsurancePlans = __webpack_require__(16061);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlansComp.tsx
var InsurancePlansComp = __webpack_require__(80549);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlansHeader.tsx
var InsurancePlansHeader = __webpack_require__(68466);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/InsurancePlanTypeSection.tsx
var InsurancePlanTypeSection = __webpack_require__(6660);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/MoreBenefits/index.ts + 1 modules
var MoreBenefits = __webpack_require__(32265);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsurancePlans/TravelAssistanceModal.tsx
var TravelAssistanceModal = __webpack_require__(18698);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/InsuranceStats/InsuranceStats.tsx + 1 modules
var InsuranceStats = __webpack_require__(89578);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ItineraryInfoComp/ItineraryInfoComp.tsx + 1 modules
var ItineraryInfoComp = __webpack_require__(39275);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingBenefits/LandingBenefits.tsx + 1 modules
var LandingBenefits = __webpack_require__(21537);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButton.tsx
var LandingButton = __webpack_require__(99660);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButtonTertiary.tsx
var LandingButtonTertiary = __webpack_require__(60707);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButton/LandingButtonWhite.tsx
var LandingButtonWhite = __webpack_require__(95329);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButtonComp/LandingButtonComp.tsx + 1 modules
var LandingButtonComp = __webpack_require__(51573);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooter.tsx + 1 modules
var LandingFooter = __webpack_require__(71791);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingFooter/LandingFooterInsurance.tsx + 1 modules
var LandingFooterInsurance = __webpack_require__(19394);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeader.tsx
var LandingHeader = __webpack_require__(18835);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingHeader/LandingHeaderMobile.tsx + 1 modules
var LandingHeaderMobile = __webpack_require__(63590);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingInput/LandingInput.tsx + 1 modules
var LandingInput = __webpack_require__(48741);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingTestimonials/LandingTestimonials.tsx + 1 modules
var LandingTestimonials = __webpack_require__(50976);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ListingEditDetails/ListingEditDetails.tsx + 1 modules
var ListingEditDetails = __webpack_require__(85167);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ListingTravelDetails/ListingTravelDetails.tsx + 1 modules
var ListingTravelDetails = __webpack_require__(10633);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ManageInsurance/ManageInsurance.tsx
var ManageInsurance = __webpack_require__(49442);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ManageInsurance/ManageInsuranceShimmer.tsx
var ManageInsuranceShimmer = __webpack_require__(16160);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/PlanCardsList/PlanCardsList.tsx + 6 modules
var PlanCardsList = __webpack_require__(14424);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/NoInsurancePlan/NoInsurancePlan.tsx + 1 modules
var NoInsurancePlan = __webpack_require__(5173);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OfferedBySection/OfferedBySection.tsx + 1 modules
var OfferedBySection = __webpack_require__(58487);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OffersBenefitsSection/OffersBenefitsSection.tsx + 1 modules
var OffersBenefitsSection = __webpack_require__(22637);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailInsurance.tsx
var OrderDetailInsurance = __webpack_require__(23558);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailPlan.tsx
var OrderDetailPlan = __webpack_require__(99180);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailPlanShimmer.tsx
var OrderDetailPlanShimmer = __webpack_require__(22026);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/OrderDetailTraveller.tsx
var OrderDetailTraveller = __webpack_require__(40455);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailComp/PrimaryContact.tsx
var PrimaryContact = __webpack_require__(28693);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderAmtPaid.tsx
var OrderAmtPaid = __webpack_require__(71527);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderGetHelp.tsx
var OrderGetHelp = __webpack_require__(41232);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderInsurance.tsx
var OrderInsurance = __webpack_require__(79229);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetailRightComp/OrderPriceBreakup.tsx
var OrderPriceBreakup = __webpack_require__(84981);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetails/OrderDetails.tsx
var OrderDetails = __webpack_require__(35311);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderDetails/OrderDetailsShimmer.tsx
var OrderDetailsShimmer = __webpack_require__(44665);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderListingComp/OrderListingComp.tsx + 1 modules
var OrderListingComp = __webpack_require__(62955);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/OrderStatusComp/OrderStatusComp.tsx + 1 modules
var OrderStatusComp = __webpack_require__(68938);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/AddPassportModal.tsx
var AddPassportModal = __webpack_require__(69749);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PassportNumComp/PassportNumComp.tsx
var PassportNumComp = __webpack_require__(31799);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PaymentOfferBreakdown/PaymentOfferBreakdown.tsx + 1 modules
var PaymentOfferBreakdown = __webpack_require__(93252);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PaymentStatusComp/PaymentStatusComp.tsx + 1 modules
var PaymentStatusComp = __webpack_require__(66365);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBanner.tsx
var PersuasionBanner = __webpack_require__(55913);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBannerInsurance.tsx
var PersuasionBannerInsurance = __webpack_require__(55654);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PlanPriceInfoComp/PlanPriceInfoComp.tsx + 1 modules
var PlanPriceInfoComp = __webpack_require__(3925);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PoweredBySection/PoweredBySection.tsx + 1 modules
var PoweredBySection = __webpack_require__(94879);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PriceBreakup/PriceBreakup.tsx + 1 modules
var PriceBreakup = __webpack_require__(76827);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PrimaryContactComp/PrimaryContactComp.tsx + 1 modules
var PrimaryContactComp = __webpack_require__(3149);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RadioButton/RadioButton.tsx
var RadioButton = __webpack_require__(11627);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RangeDatePicker/RangeDatePicker.tsx + 10 modules
var RangeDatePicker = __webpack_require__(7638);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ReactPortalComp.tsx
var ReactPortalComp = __webpack_require__(70629);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/RecentSearches/RecentSearches.tsx + 1 modules
var RecentSearches = __webpack_require__(28376);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SafenSecureTrav/SafenSecureTrav.tsx + 2 modules
var SafenSecureTrav = __webpack_require__(17251);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SectionDividers/SectionDividers.tsx
var SectionDividers = __webpack_require__(27154);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SecureTravOffer/SecureTravOffer.tsx + 1 modules
var SecureTravOffer = __webpack_require__(68314);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryCodeModal.tsx + 1 modules
var SelectCountryCodeModal = __webpack_require__(57748);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalSheetV2.tsx
var SelectCountryModalSheetV2 = __webpack_require__(76409);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SelectCountryModal/SelectCountryModalV2.tsx + 1 modules
var SelectCountryModalV2 = __webpack_require__(38051);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Shimmer/Shimmer.tsx
var Shimmer = __webpack_require__(83531);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Shimmer/ShimmerVersion2.tsx
var ShimmerVersion2 = __webpack_require__(6456);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Shimmer/ShimmerVersion3.tsx
var ShimmerVersion3 = __webpack_require__(20863);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ShowInsPlan/ShowInsPlan.tsx + 1 modules
var ShowInsPlan = __webpack_require__(60200);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/SocialLogos/SocialLogos.tsx + 1 modules
var SocialLogos = __webpack_require__(15364);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Spinner/Spinner.tsx + 1 modules
var Spinner = __webpack_require__(63161);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Tags/Tags.tsx
var Tags = __webpack_require__(95062);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TestComponent/TestComponent.tsx
var TestComponent = __webpack_require__(88939);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TestimonialsSection/TestimonialsSection.tsx + 1 modules
var TestimonialsSection = __webpack_require__(95595);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/AnchorTag.tsx
var AnchorTag = __webpack_require__(38985);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H2Tag.tsx
var H2Tag = __webpack_require__(66630);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H3Tag.tsx
var H3Tag = __webpack_require__(64696);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H4Tag.tsx
var H4Tag = __webpack_require__(14485);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H5Tag.tsx
var H5Tag = __webpack_require__(9321);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/H6Tag.tsx
var H6Tag = __webpack_require__(79562);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/ParaTag.tsx
var ParaTag = __webpack_require__(75641);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/SpanTag.tsx
var SpanTag = __webpack_require__(56893);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TickRadioComp/TickRadioComp.tsx + 1 modules
var TickRadioComp = __webpack_require__(32888);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TMFloatingInput/TMFloatingInput.tsx
var TMFloatingInput = __webpack_require__(14802);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TMNPSFeedback/index.tsx
var TMNPSFeedback = __webpack_require__(76450);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TncComp/TncComp.tsx + 1 modules
var TncComp = __webpack_require__(26217);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Toast/Toast.tsx
var Toast = __webpack_require__(2660);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Toast/ToastCompare.tsx
var ToastCompare = __webpack_require__(91703);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ToolTipComp/ToolTipComp.tsx
var ToolTipComp = __webpack_require__(94510);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TravAssistant/TravAssistant.tsx + 1 modules
var TravAssistant = __webpack_require__(54664);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravellingTo.tsx + 2 modules
var TravellingTo = __webpack_require__(16829);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TravelDetails/TravellingToShimmer.tsx
var TravellingToShimmer = __webpack_require__(89391);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 4 modules
var utils = __webpack_require__(64264);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var static_utils = __webpack_require__(84576);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/index.ts + 7 modules
var icons = __webpack_require__(64204);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellingToWidget.style.ts
var TravellingToWidget_style = __webpack_require__(89444);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravelDateWiget.tsx









const TravelDateWiget = ({
  showTravDate,
  handleTravDate,
  ref,
  travDateTitle,
  startDate,
  endDate
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravelDateWigetStyle */.Jp, {
    ref: ref,
    onClick: handleTravDate,
    "data-test-id": "TravelDateWiget-TravelDateWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      gap: "8px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [travDateTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
        textTransform: "uppercase",
        color: showTravDate ? `var(--tm-accent-color)` : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravelDateWiget-SpanTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: travDateTitle,
          "data-test-id": "TravelDateWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* ChevStateWrap */.N, {
        open: showTravDate,
        "data-test-id": "TravelDateWiget-ChevStateWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
          "data-test-id": "TravelDateWiget-BlueChev"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      gap: "4px",
      "data-test-id": "TravelDateWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [startDate?.getDate(), " \xA0", startDate ? static_utils/* MONTHS */.gg[parseInt(startDate?.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", startDate?.getFullYear().toString().slice(-2)]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: startDate && static_utils/* LONG_WEEK_DAYS */.vH[startDate.getDay()]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* DateSeparator */.ZP, {
        "data-test-id": "TravelDateWiget-DateSeparator",
        children: "-to-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        isCursorPointer: true,
        flexDirection: "column",
        gap: "0",
        "data-test-id": "TravelDateWiget-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
          fontSize: "md",
          fontWeight: "black",
          "data-test-id": "TravelDateWiget-SpanTag",
          children: [endDate ? endDate.getDate() : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? 1 : startDate.getDate() + 1 : null, "\xA0", endDate ? static_utils/* MONTHS */.gg[parseInt(endDate.getMonth().toString().slice(-2))] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? static_utils/* MONTHS */.gg[parseInt((startDate.getMonth() + 1).toString().slice(-2))] : static_utils/* MONTHS */.gg[parseInt(startDate.getMonth().toString().slice(-2))] : null, "\xA0", /*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
            fontSize: "sm",
            fontWeight: "regular",
            "data-test-id": "TravelDateWiget-SpanTag",
            children: ["'", endDate ? endDate.getFullYear().toString().slice(-2) : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? startDate.getMonth() === 11 ? (startDate.getFullYear() + 1).toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : startDate.getFullYear().toString().slice(-2) : null]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
          fontSize: "xs",
          color: Global/* theme.greyText6 */.rS.greyText6,
          "data-test-id": "TravelDateWiget-SpanTag",
          children: endDate ? static_utils/* LONG_WEEK_DAYS */.vH[endDate.getDay()] : startDate ? startDate.getDate() === new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate() ? static_utils/* LONG_WEEK_DAYS */.vH[new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1).getDay()] : static_utils/* LONG_WEEK_DAYS */.vH[startDate.getDay()] : null
        })]
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravelDateWiget = (TravelDateWiget);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.tsx + 1 modules
var WebToast = __webpack_require__(78891);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var ui_src = __webpack_require__(76609);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravAgeRangenCountPicker.tsx

















const TravAgeRangenCountPicker = ({
  travellerInfoSelectSection,
  captureCount,
  travAgeRange,
  setCaptureCount,
  setTravAgeRange,
  focusedIndex,
  ageRangeSelectIndex,
  ageRangeSelectRef,
  setIsAgeRangeSelectedError,
  setFocusedIndex,
  setAgeRangeSelectIndex,
  travellingToRef
}) => {
  const {
    countSection,
    ageRangeSection,
    ctaText
  } = travellerInfoSelectSection || {};
  const {
    0: selectPosition,
    1: setSelectPosition
  } = (0,react.useState)({
    left: 0,
    top: 0,
    bottom: 0
  });
  const {
    0: travellerCount,
    1: setTravellerCount
  } = (0,react.useState)(1);
  const {
    0: travellerAgeRange,
    1: setTravellerAgeRange
  } = (0,react.useState)([]);
  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const divRefs = (0,react.useRef)([]);
  const applyBtnRef = (0,react.useRef)(null);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const analytics = (0,insurance/* getAnalytics */.I)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();

  const handleSelectPosition = index => {
    const currentDiv = divRefs.current[index];

    if (currentDiv) {
      const rect = currentDiv.getBoundingClientRect();
      setSelectPosition({
        left: rect.x - (device === "sm" ? 8 : 0),
        top: rect.top - (device === "sm" ? 150 : 0),
        bottom: window.innerHeight - rect.top + 7
      });
    }
  };

  (0,react.useEffect)(() => {
    const button = applyBtnRef.current;
    let viewportMargin = 16;

    if (button) {
      const rect = button.getBoundingClientRect();
      const offsetTop = window.scrollY + rect.top;
      const isInViewport = offsetTop >= 0 && offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        travellingToRef?.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }
    }
  }, []);
  (0,react.useEffect)(() => {
    setTravellerCount(captureCount);
    setTravellerAgeRange(travAgeRange);
  }, [captureCount, travAgeRange, focusedIndex]);

  const handleTravellerCountIncr = () => {
    const newTravAgeRange = [...(travellerAgeRange ?? [])];

    if (travellerCount < (countSection?.maxCount ?? src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS)) {
      setTravellerCount(travellerCount + 1);
      newTravAgeRange.push({});
    } else {
      setTravellerCount(countSection?.maxCount ?? src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS);

      if (newTravAgeRange.length < src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS) {
        newTravAgeRange.push({});
      }
    }

    setTravellerAgeRange?.(newTravAgeRange);
  };

  const handleTravellerCountDecr = () => {
    const newTravAgeRange = [...(travellerAgeRange ?? [])];

    if (travellerCount > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
      newTravAgeRange.pop();
      setTravellerCount(travellerCount - 1);
    } else {
      setTravellerCount(src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS);

      if (newTravAgeRange.length > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS) {
        newTravAgeRange.pop();
      }
    }

    setTravellerAgeRange(newTravAgeRange);
  };

  const handleAgeRangeSelect = (index, value, label, key, e) => {
    setAgeRangeSelectIndex(-1);
    const newTravAgeRange = travellerAgeRange?.map((item, i) => {
      if (i === index) {
        return {
          value,
          label,
          key
        };
      }

      return item;
    });
    setTravellerAgeRange(newTravAgeRange ?? []);
    e.stopPropagation();
  };

  const handleApply = () => {
    const isAgeRangeSelected = travellerAgeRange?.every(ageRange => ageRange?.value);

    if (isAgeRangeSelected) {
      setIsAgeRangeSelectedError(false);
      setFocusedIndex(-1);
      setTravAgeRange(travellerAgeRange);
      setCaptureCount(travellerCount);
      analytics?.trackLandingEvents({
        actionType: "Ins_TravellerAndAgeModified"
      }, "pageView", type);
      (0,XDMAnalytics.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "Ins_TravellerAndAgeModified"
        }
      });
      (0,utils/* replaceHistory */.df)("travellers", travellerCount.toString());
      (0,utils/* replaceHistory */.df)("travellerAgeRanges", JSON.stringify(travellerAgeRange.map(item => item.key)));
    } else {
      setIsSelectedError(true);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerAgeRangePickerWrap */.I3, {
    isBottomSheetFullScreen: travellerCount > 10,
    "data-test-id": "TravAgeRangenCountPicker-TravellerAgeRangePickerWrap",
    children: [device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerAgenCountHeading */.aS, {
      "data-test-id": "TravAgeRangenCountPicker-TravellerAgenCountHeading",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        onClick: () => {
          setFocusedIndex(-1);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
            fill: "#808080"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
        fontSize: "md",
        fontWeight: "bold",
        color: "#4A4A4A",
        "data-test-id": "TravAgeRangenCountPicker-SpanTag",
        children: "TRAVELLERS & AGE"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* RangePickerContentWrap */.v7, {
      isBottomSheetFullScreen: travellerCount > 10,
      "data-test-id": "TravAgeRangenCountPicker-RangePickerContentWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* CountSectionWrap */.tB, {
        "data-test-id": "TravAgeRangenCountPicker-CountSectionWrap",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
          justifyContent: "space-between",
          alignItems: "center",
          "data-test-id": "TravAgeRangenCountPicker-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
            fontSize: "sm",
            "data-test-id": "TravAgeRangenCountPicker-SpanTag",
            children: countSection?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
              fontSize: "xs",
              fontWeight: "bold",
              color: "#4A4A4A",
              "data-test-id": "TravAgeRangenCountPicker-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                value: countSection?.title,
                "data-test-id": "TravAgeRangenCountPicker-FormattedText"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* CounterWrap */.vg, {
            borderRadius: "8px",
            padding: "4px",
            gap: "4px",
            height: "32px",
            boxShadow: "0px",
            border: "1px solid #D8D8D8",
            "data-test-id": "TravAgeRangenCountPicker-CounterWrap",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
              isDiabled: travellerCount == 1,
              onClick: handleTravellerCountDecr,
              "data-test-id": "TravAgeRangenCountPicker-CounterBtn",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
                  width: "24",
                  height: "24",
                  fill: "white",
                  "data-test-id": "TravAgeRangenCountPicker-rect"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M6 11.0938H17.5V12.9064H6V11.0938Z",
                  fill: "var(--tm-accent-color)"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
              fontWeight: "bold",
              fontSize: "large",
              "data-test-id": "TravAgeRangenCountPicker-SpanTag",
              children: travellerCount && travellerCount <= 9 ? "0" + travellerCount : travellerCount
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
              isDiabled: travellerCount == countSection?.maxCount,
              onClick: handleTravellerCountIncr,
              "data-test-id": "TravAgeRangenCountPicker-CounterBtn",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
                  width: "24",
                  height: "24",
                  fill: "white",
                  "data-test-id": "TravAgeRangenCountPicker-rect"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M12.612 6.04785V11.1719H17.496V12.7919H12.612V17.9519H10.86V12.7919H6V11.1719H10.86V6.04785H12.612Z",
                  fill: "var(--tm-accent-color)"
                })]
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
          fontSize: "sm",
          "data-test-id": "TravAgeRangenCountPicker-SpanTag",
          children: ageRangeSection?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: countSection?.description,
            "data-test-id": "TravAgeRangenCountPicker-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          position: "relative",
          zIndex: "-1"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDividers/* default */.Z, {
          xs: true,
          "data-test-id": "TravAgeRangenCountPicker-SectionDividers"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* AgeRangeSectionWrap */.EY, {
        isBottomSheetFullScreen: travellerCount > 10,
        "data-test-id": "TravAgeRangenCountPicker-AgeRangeSectionWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
          flexDirection: "column",
          gap: "4px",
          "data-test-id": "TravAgeRangenCountPicker-FlexComp",
          children: [ageRangeSection?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
            fontSize: "xs",
            fontWeight: "bold",
            color: "#4A4A4A",
            "data-test-id": "TravAgeRangenCountPicker-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: ageRangeSection?.title,
              "data-test-id": "TravAgeRangenCountPicker-FormattedText"
            })
          }), ageRangeSection?.description && /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
            fontSize: "xs",
            color: "#757575",
            "data-test-id": "TravAgeRangenCountPicker-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: ageRangeSection?.description,
              "data-test-id": "TravAgeRangenCountPicker-FormattedText"
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* TravellerAgeRangeSelectSection */.lJ, {
        "data-test-id": "TravAgeRangenCountPicker-TravellerAgeRangeSelectSection",
        children: travellerAgeRange?.map((ageRange, index) => {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
            alignItems: device === "sm" ? "flex-end" : "center",
            flexDirection: "column",
            "data-test-id": "TravAgeRangenCountPicker-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
              width: "100%",
              gap: "4px",
              alignItems: "center",
              justifyContent: "space-between",
              "data-test-id": "TravAgeRangenCountPicker-FlexComp",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
                fontSize: "xs",
                margin: "8px 0px",
                "data-test-id": "TravAgeRangenCountPicker-SpanTag",
                children: ["Traveller ", (index + 1).toString()]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [device === "lg" && (ageRangeSelectIndex === index ? /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* AgeRangeSelect */.t3, {
                  ref: ageRangeSelectRef,
                  top: selectPosition?.top,
                  left: selectPosition?.left,
                  "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelect",
                  children: ageRangeSection?.ageRanges && ageRangeSection?.ageRanges?.map((age, i) => {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* AgeSelectItem */.Eo, {
                      onClick: e => {
                        handleAgeRangeSelect(index, [age?.min, age?.max], age?.label, i, e);
                      },
                      "data-test-id": "TravAgeRangenCountPicker-AgeSelectItem",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                        value: age?.label,
                        baseStyle: {
                          fontSize: "12px"
                        },
                        "data-test-id": "TravAgeRangenCountPicker-FormattedText"
                      })
                    });
                  })
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* AgeRangeSelectSection */.Ov, {
                  ref: el => divRefs.current[index] = el,
                  onClick: e => {
                    setAgeRangeSelectIndex(index);
                    handleSelectPosition(index);
                    e.stopPropagation();
                  },
                  "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelectSection",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
                    justifyContent: "space-between",
                    width: "100%",
                    "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                    children: [ageRange?.value ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                      value: ageRange?.label,
                      baseStyle: {
                        fontSize: "12px",
                        fontWeight: "bold"
                      },
                      "data-test-id": "TravAgeRangenCountPicker-FormattedText"
                    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
                      fontSize: "xs",
                      color: "#4A4A4A",
                      "data-test-id": "TravAgeRangenCountPicker-SpanTag",
                      children: "Select Age"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FlexComp/* default */.Z, {
                      alignItems: "center",
                      height: "16px",
                      width: "16px",
                      isCursorPointer: true,
                      justifyContent: "center",
                      "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
                        height: "5px",
                        width: "8px",
                        src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                        "data-test-id": "TravAgeRangenCountPicker-ImageComponent"
                      })
                    })]
                  })
                })), device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* AgeRangeSelectSection */.Ov, {
                  "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelectSection",
                  children: [ageRangeSelectIndex === index && /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* AgeRangeSelectMobileWrap */.qb, {
                    top: selectPosition?.top,
                    left: selectPosition?.left,
                    bottom: selectPosition?.bottom,
                    "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelectMobileWrap",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* AgeRangeSelect */.t3, {
                      ref: ageRangeSelectRef,
                      top: selectPosition?.top,
                      left: selectPosition?.left,
                      "data-test-id": "TravAgeRangenCountPicker-AgeRangeSelect",
                      children: ageRangeSection?.ageRanges && ageRangeSection?.ageRanges?.map((age, i) => {
                        return /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* AgeSelectItem */.Eo, {
                          onClick: e => {
                            handleAgeRangeSelect(index, [age?.min, age?.max], age?.label, i, e);
                          },
                          "data-test-id": "TravAgeRangenCountPicker-AgeSelectItem",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                            value: age?.label,
                            baseStyle: {
                              fontSize: "12px"
                            },
                            "data-test-id": "TravAgeRangenCountPicker-FormattedText"
                          })
                        });
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* UpsideDownTriangle */.qX, {
                      "data-test-id": "TravAgeRangenCountPicker-UpsideDownTriangle"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    ref: el => divRefs.current[index] = el,
                    onClick: e => {
                      setAgeRangeSelectIndex(index);
                      handleSelectPosition(index);
                      e.stopPropagation();
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
                      justifyContent: "space-between",
                      width: "100%",
                      "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                      children: [ageRange?.value ? /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                        value: ageRange?.label,
                        baseStyle: {
                          fontSize: "12px",
                          fontWeight: "bold"
                        },
                        "data-test-id": "TravAgeRangenCountPicker-FormattedText"
                      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
                        fontSize: "xs",
                        color: "#4A4A4A",
                        "data-test-id": "TravAgeRangenCountPicker-SpanTag",
                        children: "Select Age"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(FlexComp/* default */.Z, {
                        alignItems: "center",
                        height: "16px",
                        width: "16px",
                        isCursorPointer: true,
                        justifyContent: "center",
                        "data-test-id": "TravAgeRangenCountPicker-FlexComp",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageComponent/* ImageComponent */.c, {
                          height: "5px",
                          width: "8px",
                          src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                          "data-test-id": "TravAgeRangenCountPicker-ImageComponent"
                        })
                      })]
                    })
                  })]
                })]
              })]
            }), isSelectedError && !ageRange?.value && /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
              fontSize: "xs",
              color: "#EB2026",
              margin: device === "lg" ? "0px 0px 0px 60px" : "0px 3px 0px 0px",
              "data-test-id": "TravAgeRangenCountPicker-SpanTag",
              children: "Select age range"
            })]
          });
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* ApplyCtaSectionWrap */.Q6, {
      "data-test-id": "TravAgeRangenCountPicker-ApplyCtaSectionWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingButton/* default */.Z, {
        customWidth: device === "sm" ? "100%" : "93px",
        customHeight: device === "sm" ? "44px" : "32px",
        customTitle: ctaText,
        fontSize: device === "sm" ? "16px" : "14px",
        onClick: handleApply,
        buttonref: applyBtnRef,
        "data-test-id": "TravAgeRangenCountPicker-LandingButton"
      })
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravAgeRangenCountPicker = (TravAgeRangenCountPicker);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellerEmailSelector/TravellerEmailSelector.style.ts



const mobileAnim = (0,styled_components_browser_esm/* keyframes */.F4)(["0%{bottom:-100%;opacity:0;}100%{bottom:0;opacity:1;}"]);
const ModalBackdrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__ModalBackdrop",
  componentId: "sc-1k2uldc-0"
})(["position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;z-index:1000;"]); // TODO: Check z-index and make it some specific value across repo

const EmailSelectorBackdrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__EmailSelectorBackdrop",
  componentId: "sc-1k2uldc-1"
})(["position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.4);z-index:9999;display:flex;align-items:flex-end;"]);
const SelectorWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__SelectorWrapper",
  componentId: "sc-1k2uldc-2"
})(["background:", ";border-radius:12px;box-shadow:0 4px 32px rgba(0,0,0,0.18);position:relative;@media ", "{min-width:340px;max-width:400px;}@media ", "{border-radius:16px 16px 0 0;box-sizing:border-box;width:100%;max-height:80vh;overflow-y:auto;position:fixed;left:0;bottom:-100%;z-index:10;animation-fill-mode:forwards;animation:", " 0.3s ease-in-out;animation-fill-mode:forwards;}"], Global/* theme.whiteText */.rS.whiteText, src.deviceType.desktop, src.deviceType.mobile, mobileAnim);
const CloseButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TravellerEmailSelectorstyle__CloseButton",
  componentId: "sc-1k2uldc-3"
})(["position:absolute;top:12px;right:12px;background:none;border:none;font-size:", ";color:", ";cursor:pointer;"], Global/* fontSize.font24 */.JB.font24, Global/* theme.greyText7 */.rS.greyText7);
const SelectorLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "TravellerEmailSelectorstyle__SelectorLabel",
  componentId: "sc-1k2uldc-4"
})(["font-weight:600;font-size:", ";margin-bottom:4px;display:block;"], Global/* fontSize.font18 */.JB.font18);
const SelectorDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__SelectorDescription",
  componentId: "sc-1k2uldc-5"
})(["background-color:#f4ebe5;color:", ";padding:5px 11px 5px 11px;font-size:", ";@media ", "{padding:8px 24px;}"], Global/* theme.greyText */.rS.greyText, Global/* fontSize.font12 */.JB.font12, src.deviceType.mobile);
const InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__InputWrapper",
  componentId: "sc-1k2uldc-6"
})(["font-size:", ";display:flex;align-items:center;background:", ";padding:0 12px;box-shadow:0px 1px 2px 0px rgba(0,0,0,0.05);height:44px;@media ", "{border-radius:16px;margin:16px 24px;border:1px solid var(--tm-accent-color);background-color:var(--tm-accent-bg-color);}"], Global/* fontSize.font14 */.JB.font14, Global/* theme.whiteText2 */.rS.whiteText2, src.deviceType.mobile);
const InputIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TravellerEmailSelectorstyle__InputIcon",
  componentId: "sc-1k2uldc-7"
})(["font-size:", ";color:", ";margin-right:8px;display:flex;align-items:center;"], Global/* fontSize.font20 */.JB.font20, Global/* theme.greyText2 */.rS.greyText2);
const TravellerInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "TravellerEmailSelectorstyle__TravellerInput",
  componentId: "sc-1k2uldc-8"
})(["border:none;background:transparent;outline:none;font-size:", ";flex:1;color:", ";height:40px;"], Global/* fontSize.font16 */.JB.font16, Global/* theme.blackText2 */.rS.blackText2);
const Dropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__Dropdown",
  componentId: "sc-1k2uldc-9"
})(["display:flex;flex-direction:column;gap:8px;"]);
const GroupSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__GroupSection",
  componentId: "sc-1k2uldc-10"
})(["margin-top:16px;"]);
const GroupLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__GroupLabel",
  componentId: "sc-1k2uldc-11"
})(["font-size:", ";color:", ";font-weight:600;margin-bottom:4px;text-transform:uppercase;letter-spacing:0.04em;"], Global/* fontSize.font14 */.JB.font14, Global/* theme.greyText7 */.rS.greyText7);
const SectionDivider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__SectionDivider",
  componentId: "sc-1k2uldc-12"
})(["height:1px;background:", ";margin:12px 0 8px 0;"], Global/* theme.gainsBoro */.rS.gainsBoro);
const OptionRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__OptionRow",
  componentId: "sc-1k2uldc-13"
})(["display:flex;align-items:flex-start;gap:8px;padding:10px 8px;border-radius:6px;cursor:pointer;transition:background 0.15s,border 0.15s;&:hover{background:var(--tm-accent-bg-color);}"]);
const Dot = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TravellerEmailSelectorstyle__Dot",
  componentId: "sc-1k2uldc-14"
})(["width:4px;height:20px;border-radius:10px;display:inline-block;margin-top:3px;background:", ";"], ({
  color
}) => color || Global/* theme.greyText6 */.rS.greyText6);
const OptionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__OptionContent",
  componentId: "sc-1k2uldc-15"
})(["display:flex;flex-direction:column;flex:1;"]);
const Name = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TravellerEmailSelectorstyle__Name",
  componentId: "sc-1k2uldc-16"
})(["font-weight:600;font-size:", ";color:", ";"], Global/* fontSize.font16 */.JB.font16, Global/* theme.blackText2 */.rS.blackText2);
const Badge = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "TravellerEmailSelectorstyle__Badge",
  componentId: "sc-1k2uldc-17"
})(["background:", ";color:", ";font-size:", ";font-weight:700;border-radius:6px;padding:2px 8px;margin-left:8px;"], Global/* theme.whiteText */.rS.whiteText, ({
  color
}) => color || Global/* theme.greyText6 */.rS.greyText6, Global/* fontSize.font12 */.JB.font12);
const OptionEmail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__OptionEmail",
  componentId: "sc-1k2uldc-18"
})(["font-size:", ";color:", ";margin-top:2px;"], Global/* fontSize.font14 */.JB.font14, Global/* theme.greyText7 */.rS.greyText7);
const Email = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__Email",
  componentId: "sc-1k2uldc-19"
})(["font-size:", ";color:", ";margin-left:auto;"], Global/* fontSize.font14 */.JB.font14, Global/* theme.greyText7 */.rS.greyText7);
const Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__Description",
  componentId: "sc-1k2uldc-20"
})(["font-size:", ";color:", ";margin-top:2px;"], Global/* fontSize.font14 */.JB.font14, Global/* theme.greyText2 */.rS.greyText2);
const ColleagueTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__ColleagueTitle",
  componentId: "sc-1k2uldc-21"
})(["font-size:", ";color:", ";margin-top:2px;margin-left:16px;"], Global/* fontSize.font14 */.JB.font14, Global/* theme.greyText7 */.rS.greyText7);
const NoUserFoundMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravellerEmailSelectorstyle__NoUserFoundMessage",
  componentId: "sc-1k2uldc-22"
})(["background-color:", ";color:", ";padding:20px;text-align:center;font-size:", ";border-radius:6px;margin:8px;"], Global/* theme.gainsBoro */.rS.gainsBoro, Global/* theme.greyText6 */.rS.greyText6, Global/* fontSize.font14 */.JB.font14);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellerEmailSelector/TravellerEmailSelector.tsx











const TravellerEmailSelector = ({
  label,
  description,
  options,
  colleagueOptions,
  onClose,
  onSelect,
  onSearch
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  (0,react.useEffect)(() => {
    return () => {
      onClose();
    };
  }, []);

  const handleSelect = option => {
    onSelect({
      text: option?.text || "",
      subText: option?.subText || "",
      id: option?.id || ""
    });
    (0,utils/* replaceHistory */.df)("bookingFor", option?.id || "");
    onClose();
  };

  const isNoUserFound = (!options || options?.length === 0) && (!colleagueOptions || colleagueOptions?.length === 0);

  const renderOptions = options => {
    return options?.map(option => /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionRow, {
      onClick: () => handleSelect(option),
      "data-test-id": "TravellerEmailSelector-renderOptions-StyledOptionRow",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dot, {
        color: option.color,
        "data-test-id": "TravellerEmailSelector-renderOptions-Dot"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OptionContent, {
        "data-test-id": "TravellerEmailSelector-renderOptions-OptionContent",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
          "data-test-id": "TravellerEmailSelector-renderOptions-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
            "data-test-id": "TravellerEmailSelector-renderOptions-Name",
            children: option.text
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Badge, {
            color: option.color,
            "data-test-id": "TravellerEmailSelector-renderOptions-Badge",
            children: option.badge
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(OptionEmail, {
          "data-test-id": "TravellerEmailSelector-renderOptions-OptionEmail",
          children: option.subText
        })]
      })]
    }, option.id));
  };

  const selectorComp = /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectorWrapper, {
    onClick: e => e.stopPropagation(),
    "data-test-id": "TravellerEmailSelector-selectorComp-SelectorWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputWrapper, {
      "data-test-id": "TravellerEmailSelector-selectorComp-InputWrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputIcon, {
        "data-test-id": "TravellerEmailSelector-selectorComp-InputIcon",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          role: "img",
          "aria-label": "user",
          children: "\uD83D\uDC64"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerInput, {
        onChange: e => {
          onSearch(e);
        },
        placeholder: label,
        autoFocus: true,
        "data-test-id": "TravellerEmailSelector-selectorComp-TravellerInput"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SelectorDescription, {
      "data-test-id": "TravellerEmailSelector-selectorComp-SelectorDescription",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: description,
        "data-test-id": "TravellerEmailSelector-selectorComp-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, {
      "data-test-id": "TravellerEmailSelector-selectorComp-Dropdown",
      children: isNoUserFound ? /*#__PURE__*/(0,jsx_runtime.jsx)(NoUserFoundMessage, {
        "data-test-id": "TravellerEmailSelector-selectorComp-NoUserFoundMessage",
        children: "No user found with this name"
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [renderOptions(options), colleagueOptions && colleagueOptions?.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ColleagueTitle, {
            "data-test-id": "TravellerEmailSelector-selectorComp-ColleagueTitle",
            children: src.COLLEAGUES_TITLE
          }), renderOptions(colleagueOptions)]
        })]
      })
    })]
  });

  return device === "sm" ? /*#__PURE__*/(0,jsx_runtime.jsx)(EmailSelectorBackdrop, {
    onClick: onClose,
    "data-test-id": "TravellerEmailSelector-EmailSelectorBackdrop",
    children: selectorComp
  }) : selectorComp;
};

/* harmony default export */ const TravellerEmailSelector_TravellerEmailSelector = (TravellerEmailSelector);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellerBookingForWidget.tsx















const TravellerBookingForWidget = ({
  travellerBookingFor,
  captureCount,
  travCounterTitle,
  setCaptureCount
}) => {
  const {
    0: showTravCounterDropdown,
    1: setShowTravCounterDropdown
  } = (0,react.useState)(false);
  const {
    0: showTravBookingForDropdown,
    1: setShowTravBookingForDropdown
  } = (0,react.useState)(false);
  const {
    0: selectedBookingFor,
    1: setSelectedBookingFor
  } = (0,react.useState)({
    text: travellerBookingFor?.defaultSelected?.text || "",
    subText: travellerBookingFor?.defaultSelected?.subText || "",
    id: travellerBookingFor?.id || ""
  });
  const {
    0: displayOptions,
    1: setDisplayOptions
  } = (0,react.useState)({
    userOptions: travellerBookingFor?.searchDropDown?.userOptions || [],
    colleagueOptions: travellerBookingFor?.searchDropDown?.colleagueOptions || null
  });
  const {
    0: searchValue,
    1: setSearchValue
  } = (0,react.useState)("");
  const travCounterDropdownRef = (0,react.useRef)(null);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  (0,react.useEffect)(() => {
    function handleClickOutsideTravCounter(event) {
      if (travCounterDropdownRef.current && !travCounterDropdownRef.current.contains(event.target)) {
        setShowTravCounterDropdown(false);
      }
    }

    if (showTravCounterDropdown) {
      document.addEventListener("mousedown", handleClickOutsideTravCounter);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideTravCounter);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideTravCounter);
    };
  }, [showTravCounterDropdown]);

  const handleCloseTravBookingForDropdown = () => {
    setShowTravBookingForDropdown(false);
    setDisplayOptions({
      userOptions: travellerBookingFor?.searchDropDown?.userOptions || [],
      colleagueOptions: travellerBookingFor?.searchDropDown?.colleagueOptions || null
    });
  };

  const travBookingForDropdownRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if (device !== "lg") return;

    function handleClickOutsideTravBookingFor(event) {
      if (travBookingForDropdownRef.current && !travBookingForDropdownRef.current?.contains(event.target)) {
        setShowTravBookingForDropdown(false);
      }
    }

    if (showTravBookingForDropdown) {
      document.addEventListener("mousedown", handleClickOutsideTravBookingFor);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideTravBookingFor);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideTravBookingFor);
    };
  }, [showTravBookingForDropdown, device]); // Prepare dropdown items for traveller count selection

  const travellerCountOptions = Array.from({
    length: 20
  }, (_, i) => i + 1).map(num => /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCounterDropdownItem */.iC, {
    selected: num === captureCount,
    onClick: e => {
      e.stopPropagation();
      setCaptureCount(num);
      (0,utils/* replaceHistory */.df)("travellers", num.toString());
      setShowTravCounterDropdown(false);
    },
    "data-test-id": `TravellerBookingForWidget-travellerCountOptions-TravellerCounterDropdownItem-${num}`,
    children: [num, " Traveller", num !== 1 ? "s" : ""]
  }, num)); // TODO: Create a function for getting url params data where the params name needs to be configured in a constant

  const performSearch = (0,react.useCallback)(async searchTerm => {
    const response = await (0,api/* getSuggestionsInfo */.aK)({
      pattern: searchTerm,
      pageSize: src.AUTO_SUGGESTION_PAGE_SIZE,
      partner: src.PARTNER.MYBIZ,
      query: {
        itineraryId: new URLSearchParams(window.location.search).get("itineraryId") || ""
      }
    });
    setDisplayOptions({
      userOptions: response?.data?.suggestions || [],
      colleagueOptions: null
    });
  }, []);

  const onSearch = e => {
    const value = e.target.value;
    setSearchValue(value);
  };

  (0,react.useEffect)(() => {
    if (searchValue.length <= 2) {
      setDisplayOptions({
        userOptions: travellerBookingFor?.searchDropDown?.userOptions || [],
        colleagueOptions: travellerBookingFor?.searchDropDown?.colleagueOptions || null
      });
      return;
    }

    const timeoutId = setTimeout(() => {
      performSearch(searchValue);
    }, 300);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchValue, performSearch]);

  const emailSelectorComp = () => {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(TravellerEmailSelector_TravellerEmailSelector, {
      label: travellerBookingFor?.searchDropDown?.label,
      description: travellerBookingFor?.searchDropDown?.description,
      options: displayOptions?.userOptions,
      onSelect: setSelectedBookingFor,
      onClose: handleCloseTravBookingForDropdown,
      colleagueOptions: displayOptions?.colleagueOptions,
      onSearch: onSearch,
      "data-test-id": "TravellerBookingForWidget-emailSelectorComp-TravellerEmailSelector"
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCounterComboBox */.i0, {
      ref: travCounterDropdownRef,
      onClick: () => setShowTravCounterDropdown(prev => !prev),
      "data-test-id": "TravellerBookingForWidget-TravellerCounterComboBox",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        gap: "8px",
        "data-test-id": "TravellerBookingForWidget-FlexComp",
        children: [travCounterTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
          textTransform: "uppercase",
          color: showTravCounterDropdown ? `var(--tm-accent-color)` : Global/* theme.greyText */.rS.greyText,
          fontWeight: "bold",
          fontSize: "xs",
          "data-test-id": "TravellerBookingForWidget-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: travCounterTitle?.title,
            "data-test-id": "TravellerBookingForWidget-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* ChevStateWrap */.N, {
          open: showTravCounterDropdown,
          "data-test-id": "TravellerBookingForWidget-ChevStateWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
            "data-test-id": "TravellerBookingForWidget-BlueChev"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        "data-test-id": "TravellerBookingForWidget-FlexComp",
        children: [captureCount, " Traveller", captureCount !== 1 ? "s" : ""]
      }), showTravCounterDropdown && /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* TravellerCounterDropdown */.b1, {
        "data-test-id": "TravellerBookingForWidget-TravellerCounterDropdown",
        children: travellerCountOptions
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerBookingForComboBox */.sq, {
      ref: travBookingForDropdownRef,
      style: {
        position: "relative"
      },
      "data-test-id": "TravellerBookingForWidget-TravellerBookingForComboBox",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        onClick: () => setShowTravBookingForDropdown(!showTravBookingForDropdown),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
          gap: "8px",
          "data-test-id": "TravellerBookingForWidget-FlexComp",
          children: [travellerBookingFor && /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
            textTransform: "uppercase",
            color: showTravBookingForDropdown ? `var(--tm-accent-color)` : Global/* theme.greyText */.rS.greyText,
            fontWeight: "bold",
            fontSize: "xs",
            "data-test-id": "TravellerBookingForWidget-SpanTag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: travellerBookingFor?.title,
              "data-test-id": "TravellerBookingForWidget-FormattedText"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* ChevStateWrap */.N, {
            open: showTravBookingForDropdown,
            "data-test-id": "TravellerBookingForWidget-ChevStateWrap",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
              "data-test-id": "TravellerBookingForWidget-BlueChev"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
          flexDirection: "column",
          "data-test-id": "TravellerBookingForWidget-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* BookingForName */.QT, {
            "data-test-id": "TravellerBookingForWidget-BookingForName",
            children: selectedBookingFor?.text
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* BookingForMail */.UZ, {
            "data-test-id": "TravellerBookingForWidget-BookingForMail",
            children: selectedBookingFor?.subText
          })]
        })]
      }), showTravBookingForDropdown && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          position: "absolute",
          top: "100%",
          left: 0,
          zIndex: 1000,
          width: "100%"
        },
        children: emailSelectorComp()
      }), showTravBookingForDropdown && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(ReactPortalComp/* default */.Z, {
        "data-test-id": "TravellerBookingForWidget-ReactPortalComp",
        children: emailSelectorComp()
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellerBookingForWidget = (TravellerBookingForWidget);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellerCounterWiget.tsx








const TravellerCounterWiget = ({
  showTravCount,
  maxTravAllowed,
  minTravAllowed,
  handleCaptureCountIncr,
  handleCaptureCountDecr,
  captureCount,
  ref,
  travCountTitle,
  travCountSubtitle,
  travCountInfo
}) => {
  const analytics = (0,insurance/* getAnalytics */.I)();

  const handleCaptureCountIncrWithAnalytics = () => {
    analytics?.trackLandingEvents({
      actionType: "number_of_travellers_increment_clicked"
    });
    handleCaptureCountIncr?.();
  };

  const handleCaptureCountDecrWithAnalytics = () => {
    analytics?.trackLandingEvents({
      actionType: "number_of_travellers_decrement_clicked"
    });
    handleCaptureCountDecr?.();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellerCountWigetStyle */.Dq, {
    "data-test-id": "TravellerCounterWiget-TravellerCountWigetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      flexDirection: "column",
      "data-test-id": "TravellerCounterWiget-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
        textTransform: "uppercase",
        color: showTravCount ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
        fontWeight: "bold",
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: travCountTitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
        color: Global/* theme.greyText6 */.rS.greyText6,
        fontSize: "xs",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: travCountSubtitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: travCountSubtitle,
          "data-test-id": "TravellerCounterWiget-FormattedText"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* CounterWrap */.vg, {
      "data-test-id": "TravellerCounterWiget-CounterWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
        isDiabled: captureCount == minTravAllowed,
        onClick: handleCaptureCountDecrWithAnalytics,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6 11.0938H17.5V12.9064H6V11.0938Z",
            fill: "var(--tm-accent-color)"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
        fontWeight: "bold",
        fontSize: "md",
        "data-test-id": "TravellerCounterWiget-SpanTag",
        children: captureCount && captureCount <= 9 ? "0" + captureCount : captureCount
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* CounterBtn */.ZN, {
        isDiabled: captureCount == maxTravAllowed,
        onClick: handleCaptureCountIncrWithAnalytics,
        "data-test-id": "TravellerCounterWiget-CounterBtn",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "data-test-id": "TravellerCounterWiget-rect"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.612 6.04785V11.1719H17.496V12.7919H12.612V17.9519H10.86V12.7919H6V11.1719H10.86V6.04785H12.612Z",
            fill: "var(--tm-accent-color)"
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellerCounterWiget = (TravellerCounterWiget);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellerCounterWigetV2.tsx








const TravellerCounterWigetV2 = ({
  countValue,
  travSelectTitle,
  postSelectTitle,
  postSelectDesc,
  travCountTitle,
  isAgeRangeSelected,
  showSelectSection,
  handleSelectSection,
  description,
  travAgeRange
}) => {
  const getAgeRanges = travAgeRange => {
    let ageRanges = travAgeRange.map(ageRange => {
      return ageRange?.label?.text?.value;
    });
    var ageRangesStr = ageRanges.join(", ");

    if (ageRangesStr.length > 25) {
      return ageRangesStr.substring(0, 25) + "...";
    } else {
      return ageRangesStr;
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* TravellerCountWigetStyle */.Dq, {
    onClick: handleSelectSection,
    "data-test-id": "TravellerCounterWigetV2-TravellerCountWigetStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
      flexDirection: "column",
      "data-test-id": "TravellerCounterWigetV2-FlexComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        gap: "8px",
        "data-test-id": "TravellerCounterWigetV2-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
          textTransform: "uppercase",
          color: showSelectSection ? Global/* theme.blueText */.rS.blueText : Global/* theme.greyText */.rS.greyText,
          fontWeight: "bold",
          fontSize: "xs",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: travCountTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: travCountTitle,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_style/* ChevStateWrap */.N, {
          open: showSelectSection,
          "data-test-id": "TravellerCounterWigetV2-ChevStateWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
            "data-test-id": "TravellerCounterWigetV2-BlueChev"
          })
        })]
      }), isAgeRangeSelected ? /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        flexDirection: "column",
        gap: "0px",
        "data-test-id": "TravellerCounterWigetV2-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
          fontWeight: "black",
          fontSize: "md",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: [countValue, " ", postSelectTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: postSelectTitle,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SpanTag/* default */.Z, {
          color: Global/* theme.greyText6 */.rS.greyText6,
          fontSize: "xs",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: [postSelectDesc && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: postSelectDesc,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          }), " ", getAgeRanges(travAgeRange ?? [])]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        flexDirection: "column",
        gap: "0px",
        "data-test-id": "TravellerCounterWigetV2-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
          fontWeight: "black",
          fontSize: "md",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: travSelectTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: travSelectTitle,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SpanTag/* default */.Z, {
          color: Global/* theme.greyText6 */.rS.greyText6,
          fontSize: "xs",
          "data-test-id": "TravellerCounterWigetV2-SpanTag",
          children: description && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: description,
            "data-test-id": "TravellerCounterWigetV2-FormattedText"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ const TravellingToWidget_TravellerCounterWigetV2 = (TravellerCounterWigetV2);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravellingToWidget/TravellingToWidget.tsx
















 // Dynamic load date picker components for code splitting



const TravellingToWidget_DatePickerComp = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 85891)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(85891)]
  }
});
const TravellingToWidget_RangeDatePicker = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7638)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(7638)]
  }
});
const analytics = (0,insurance/* getAnalytics */.I)();

const TravellingToWidget = ({
  travelPurposeTxt,
  travCountTitle,
  travCountSubtitle,
  travCountLimit,
  travPurpTitle,
  travDateTitle,
  btnDisabledState,
  countValue,
  setCountValue,
  calendarDatesLimit,
  setCalenderValue,
  calenderRef,
  travAgeRange,
  setTravAgeRange,
  upcomingTravellerNum,
  upcomingFromDate,
  upcomingToDate,
  setIsAgeRangeSelectedError,
  calendarConfig,
  travellerInfoSection,
  travellingToRef,
  travellerBookingFor,
  travCounterTitle,
  selectedSegment,
  lastCalendarTypeSingle,
  query
}) => {
  const maxTravAllowed = travCountLimit?.max || ((0,utils/* isMyPartner */.bR)() ? 10 : src.TRAVELLER_NUMBER_CONSTANTS.MAX_TRAVELLERS);
  const minTravAllowed = travCountLimit?.min || src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS;
  const {
    endDateErrorMessage,
    insPurchaseDateLimitInDays,
    //total no. of allowed days from start date (for end date)
    insPurchaseEndDateLimitInDays,
    //max no. of allowed days from start date (for end date)
    insPurchaseStartDateLimitInDays,
    //max no. of allowed days from current date (for start date)
    insPurchaseStartDateMinLimitInDays,
    //min no. of days from current date (for start date)
    startDateErrorMessage,
    insPurchaseEndDateMinLimitInDays
  } = (calendarConfig ? calendarConfig : calendarDatesLimit) || {}; // Extract durationAllowed from calendarConfig if it exists

  const durationAllowed = calendarConfig?.durationAllowed;
  const minStartDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateMinLimitInDays);

  const getToDate = () => {
    if (query?.endDate) {
      return (0,static_utils/* convertUnixToDate */.P9)(parseInt(query?.endDate));
    }

    if (durationAllowed) {
      return (0,utils/* addDaysToDate */.Xz)(new Date(), durationAllowed);
    }

    return (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseEndDateMinLimitInDays);
  };

  const defaultSelected = () => {
    return {
      from: query?.startDate ? (0,static_utils/* convertUnixToDate */.P9)(parseInt(query?.startDate)) : (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateMinLimitInDays),
      to: getToDate()
    };
  };

  const maxEndDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseDateLimitInDays);
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const ref = (0,react.useRef)(null);
  const ageRangeSelectRef = (0,react.useRef)(null);
  const divRefs = (0,react.useRef)([]);
  const userDateChanged = (0,react.useRef)(false);
  const {
    0: captureCount,
    1: setCaptureCount
  } = (0,react.useState)(1);
  const {
    0: dateTab,
    1: setDateTab
  } = (0,react.useState)(0);
  const {
    0: range,
    1: setRange
  } = (0,react.useState)(defaultSelected());
  const {
    0: showToast,
    1: setShowToast
  } = (0,react.useState)(false);
  const {
    0: toastMessage,
    1: setToastMessage
  } = (0,react.useState)("");
  const {
    0: startDate,
    1: setStartDate
  } = (0,react.useState)(new Date());
  const {
    0: endDate,
    1: setEndDate
  } = (0,react.useState)();
  const {
    0: focusedIndex,
    1: setFocusedIndex
  } = (0,react.useState)(-1);
  const {
    0: isAgeRangeSelected,
    1: setIsAgeRangeSelected
  } = (0,react.useState)(false);
  const {
    0: ageRangeSelectIndex,
    1: setAgeRangeSelectIndex
  } = (0,react.useState)(-1);
  const {
    0: showDateChangeToast,
    1: setShowDateChangeToast
  } = (0,react.useState)(false);
  const {
    0: dateChangeToastMessage,
    1: setDateChangeToastMessage
  } = (0,react.useState)(null);
  const prevFocusedIndexRef = (0,react.useRef)(focusedIndex);
  (0,react.useEffect)(() => {
    const minThresholdDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateMinLimitInDays);
    const queryParams = new URLSearchParams(window.location.search);
    const startDateParam = queryParams.get("startDate");
    const endDateParam = queryParams.get("endDate");
    let newFromDate = minThresholdDate;

    if (newFromDate && selectedSegment?.calenderSelectionType === "SINGLE" && durationAllowed) {
      const fromDate = range?.from || new Date();

      if (startDateParam) {
        newFromDate = (0,static_utils/* convertUnixToDate */.P9)(parseInt(startDateParam));
      }

      const toDate = (0,utils/* addDaysToDate */.Xz)(newFromDate, durationAllowed);

      if (toDate && range?.to && (0,utils/* formatDate */.p6)(toDate, src.DATE_FORMATS["DD/MM/YYYY"]) !== (0,utils/* formatDate */.p6)(range?.to, src.DATE_FORMATS["DD/MM/YYYY"])) {
        setShowDateChangeToast(true);
        const hydratedSegment = (0,utils/* hydrateVars */.iX)(selectedSegment?.toast?.message, {
          END_DATE: (0,utils/* formatDate */.p6)(toDate, src.DATE_FORMATS["DD MMM YYYY"])
        });
        setDateChangeToastMessage(hydratedSegment);
      }

      replaceDateInQuery({
        startDate: newFromDate,
        endDate: toDate
      });
      setRange({
        from: newFromDate,
        to: toDate
      });
    } else {
      if (startDateParam) {
        newFromDate = (0,static_utils/* convertUnixToDate */.P9)(parseInt(startDateParam));
      }

      let toDate = newFromDate ? (0,utils/* addDaysToDate */.Xz)(newFromDate, insPurchaseEndDateMinLimitInDays) : (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseEndDateMinLimitInDays);

      if (endDateParam && !lastCalendarTypeSingle && selectedSegment?.calenderSelectionType !== "SINGLE") {
        toDate = (0,static_utils/* convertUnixToDate */.P9)(parseInt(endDateParam));
      }

      if (toDate && range?.to && (0,utils/* formatDate */.p6)(toDate, src.DATE_FORMATS["DD/MM/YYYY"]) !== (0,utils/* formatDate */.p6)(range?.to, src.DATE_FORMATS["DD/MM/YYYY"])) {
        setShowDateChangeToast(true);
        const hydratedSegment = (0,utils/* hydrateVars */.iX)(selectedSegment?.toast?.message, {
          END_DATE: (0,utils/* formatDate */.p6)(toDate, src.DATE_FORMATS["DD MMM YYYY"])
        });
        setDateChangeToastMessage(hydratedSegment);
      }

      replaceDateInQuery({
        startDate: newFromDate,
        endDate: toDate
      });
      setRange({
        from: newFromDate,
        to: toDate
      });
    }
  }, [selectedSegment]);
  (0,react.useEffect)(() => {
    if (showDateChangeToast) {
      setTimeout(() => {
        setShowDateChangeToast(false);
      }, 3000);
    }
  }, [showDateChangeToast]);

  const replaceDateInQuery = ({
    startDate,
    endDate
  }) => {
    if (startDate) {
      (0,utils/* replaceHistory */.df)("startDate", (0,static_utils/* convertDateToUnix */.cJ)(startDate).toString());
    }

    if (endDate) {
      (0,utils/* replaceHistory */.df)("endDate", (0,static_utils/* convertDateToUnix */.cJ)(endDate).toString());
    }
  };

  const handleClickOutside = event => {
    if (ref?.current && !ref?.current?.contains(event.target)) {
      setFocusedIndex(-1);
      setShowToast(false);
    }

    if (ageRangeSelectRef?.current && !ageRangeSelectRef?.current?.contains(event.target)) {
      setAgeRangeSelectIndex(-1);
    }
  };

  const handleWindowScroll = e => {
    if (ageRangeSelectRef.current) {
      const rect = ageRangeSelectRef.current.getBoundingClientRect();

      if (e.target !== ageRangeSelectRef.current && (window.scrollY < rect.top || window.scrollY > rect.bottom)) {
        setAgeRangeSelectIndex(-1);
      }
    }
  };

  const addTravellerNumber = travNumber => {
    if (travNumber > maxTravAllowed || travNumber < minTravAllowed) {
      setCaptureCount(minTravAllowed);
      (0,utils/* replaceHistory */.df)("travellers", minTravAllowed.toString());
    } else {
      setCaptureCount(travNumber);
      (0,utils/* replaceHistory */.df)("travellers", travNumber.toString());
    }
  };

  const addTravellerDates = (travStartDate, travEndDate) => {
    const tempFromDate = (0,static_utils/* convertUnixToDate */.P9)(travStartDate);
    const tempToDate = (0,static_utils/* convertUnixToDate */.P9)(travEndDate);
    (0,utils/* replaceHistory */.df)("startDate", travStartDate.toString());
    (0,utils/* replaceHistory */.df)("endDate", travEndDate.toString());
    setRange({
      from: tempFromDate,
      to: tempToDate
    });
  };

  (0,react.useEffect)(() => {
    document.addEventListener("click", handleClickOutside, false);
    document.addEventListener("scroll", handleWindowScroll, false);
    return () => {
      document.removeEventListener("scroll", handleClickOutside, false);
      document.removeEventListener("click", handleWindowScroll, false);
    };
  }, []);
  (0,react.useEffect)(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const trav = queryParameters.get("travellers");
    const fromDate = queryParameters.get("startDate");
    const toDate = queryParameters.get("endDate");
    const travellerAgeRangesIndex = JSON.parse(queryParameters.get("travellerAgeRanges") ?? "[]");

    if (trav && !Number.isNaN(parseInt(trav))) {
      addTravellerNumber(parseInt(trav));
    } else if (upcomingTravellerNum) {
      addTravellerNumber(upcomingTravellerNum);
    }

    const diff = (trav && !Number.isNaN(parseInt(trav)) ? parseInt(trav) : 1) - travellerAgeRangesIndex.length;
    const newTravAgeRange = [];
    const ageRange = travellerInfoSection?.travellerInfoSelectSection?.ageRangeSection?.ageRanges;
    travellerAgeRangesIndex.forEach((item, index) => {
      newTravAgeRange.push({
        value: [ageRange?.[item]?.min, ageRange?.[item]?.max],
        label: ageRange?.[item]?.label,
        key: item
      });
    });

    if (diff >= 0) {
      for (let i = 0; i < diff; i++) {
        newTravAgeRange.push({});
      }
    } else {
      newTravAgeRange.splice(diff, -diff);
    }

    setTravAgeRange?.(newTravAgeRange);

    if (fromDate && toDate) {
      addTravellerDates(parseInt(fromDate), parseInt(toDate));
    } else if (upcomingFromDate && upcomingToDate) {
      addTravellerDates(upcomingFromDate, upcomingToDate);
    }
  }, []);
  (0,react.useEffect)(() => {
    setEndDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
  }, []);
  (0,react.useEffect)(() => {
    if (captureCount >= minTravAllowed) {
      setCountValue(captureCount);
    }
  }, [captureCount]);
  (0,react.useEffect)(() => {
    if (range) {
      setCalenderValue(range);
    }
  }, [range]);

  const checkIsAgeRangeSelected = travAgeRange => {
    if (travAgeRange.length > 0) {
      var isAgenCountApply = travAgeRange.length === captureCount;
      travAgeRange?.forEach(item => {
        if (!item.value) {
          isAgenCountApply = false;
        }
      });
      setIsAgeRangeSelected(isAgenCountApply);
    }
  };

  (0,react.useEffect)(() => {
    checkIsAgeRangeSelected(travAgeRange ?? []);
  }, [travAgeRange]);
  (0,react.useEffect)(() => {
    const datePickerElement = document.getElementById("datePickerContainer");

    if (datePickerElement) {
      const rect = datePickerElement.getBoundingClientRect();
      const isInView = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (prevFocusedIndexRef.current === 0 && focusedIndex !== 0) {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (focusedIndex === 0 && !isInView) {
        const offset = rect.top + rect.height / 2 - window.innerHeight / 2;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    }

    prevFocusedIndexRef.current = focusedIndex;
  }, [focusedIndex]);
  (0,react.useEffect)(() => {
    if (range?.to === undefined && range?.from) {
      let tempToDate = new Date(range?.from);
      tempToDate.setDate(tempToDate.getDate() + 1);
      (0,utils/* replaceHistory */.df)("endDate", (0,static_utils/* convertDateToUnix */.cJ)(tempToDate).toString());
    }
  }, [range?.from]);

  const handleClick = index => {
    if (index === focusedIndex) {
      setFocusedIndex(-1);
      setShowToast(false);
    } else {
      setFocusedIndex(index);

      if (index === 3) {
        analytics?.trackLandingEvents({
          actionType: "Ins_TravellerAndAgeDropDownClicked"
        } //"click"
        );
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "Ins_TravellerAndAgeDropDownClicked"
          }
        });
      } else if (index === 0) {
        analytics?.trackLandingEvents({
          actionType: "Ins_TravelDateDropDownClicked"
        } //"click"
        );
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "Ins_TravelDateDropDownClicked"
          }
        });
      }
    }
  };

  const handleDayClick = selectedDate => {
    if (dateTab === 0) {
      const maxStartDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateLimitInDays);

      if (maxStartDate && maxStartDate < selectedDate) {
        // alert(startDateErrorMessage);
        setShowToast(true);
        setToastMessage(startDateErrorMessage);
      } else if (range?.from && range?.to) {
        setRange({
          from: selectedDate,
          to: undefined
        });
        (0,utils/* replaceHistory */.df)("startDate", (0,static_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
        setDateTab(1);
        setShowToast(false);
      }
    } else if (dateTab === 1) {
      if (range?.from) {
        const fromDate = new Date(range?.from);
        const maxEndDate = (0,utils/* addDaysToDate */.Xz)(fromDate, calendarConfig?.insPurchaseEndDateLimitInDays);

        if (range?.from > selectedDate) {
          setRange({
            from: selectedDate,
            to: undefined
          });
          setShowToast(false);
        } else if (maxEndDate && maxEndDate <= selectedDate) {
          setShowToast(true);
          setToastMessage(endDateErrorMessage);
        } else {
          setRange({
            from: range?.from,
            to: selectedDate
          });
          setShowToast(false);
          setDateTab(0);

          if (device == "lg") {
            setFocusedIndex(1);
            analytics?.trackLandingEvents({
              actionType: "travel_date_selected",
              payload: {
                departure: range.from?.toLocaleDateString("en-GB")?.replace(/\//gi, ":"),
                arrival: selectedDate?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || ""
              }
            } //"click"
            );
            (0,XDMAnalytics.trackEvent)({
              event_detail: {
                event_type: "action",
                event_name: "component_cta-clicked",
                event_value: "travel_date_selected"
              }
            }, {
              fromDateTime: (0,static_utils/* convertDateToUnix */.cJ)(range?.from),
              toDateTime: (0,static_utils/* convertDateToUnix */.cJ)(selectedDate)
            });
          }

          (0,utils/* replaceHistory */.df)("endDate", (0,static_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
        }
      }
    }
  };

  const handleCaptureCountIncr = () => {
    captureCount < maxTravAllowed ? setCaptureCount(captureCount + 1) : setCaptureCount(maxTravAllowed);
    (0,XDMAnalytics.updateSearchContext)({
      travellers: captureCount < maxTravAllowed ? captureCount + 1 : maxTravAllowed
    });
    (0,utils/* replaceHistory */.df)("travellers", (captureCount + 1).toString());
  };

  const handleCaptureCountDecr = () => {
    captureCount > minTravAllowed ? setCaptureCount(captureCount - 1) : setCaptureCount(minTravAllowed); // if (device == 'lg') {
    //     setFocusedIndex(2);
    // }

    (0,XDMAnalytics.updateSearchContext)({
      travellers: captureCount > src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS ? captureCount - 1 : src.TRAVELLER_NUMBER_CONSTANTS.MIN_TRAVELLERS
    });
    (0,utils/* replaceHistory */.df)("travellers", (captureCount - 1).toString());
  };

  const handleSingleDateSelect = selectedDate => {
    // Validate selected date against max start date
    const maxStartDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseStartDateLimitInDays);

    if (maxStartDate && maxStartDate < selectedDate) {
      setShowToast(true);
      setToastMessage(startDateErrorMessage);
      return;
    } // Auto-calculate end date based on business logic


    let autoEndDate;

    if (durationAllowed && selectedSegment?.calenderSelectionType === "SINGLE") {
      // For multi-trip, use the duration allowed
      autoEndDate = (0,utils/* addDaysToDate */.Xz)(selectedDate, durationAllowed) || selectedDate;
    } else {
      // For single trip, use the minimum end date limit
      autoEndDate = (0,utils/* addDaysToDate */.Xz)(selectedDate, insPurchaseEndDateMinLimitInDays) || selectedDate;
    } // Validate auto-calculated end date against max end date


    const maxAllowedEndDate = (0,utils/* addDaysToDate */.Xz)(new Date(), insPurchaseDateLimitInDays);

    if (maxAllowedEndDate && maxAllowedEndDate < autoEndDate) {
      // If auto-calculated end date exceeds limit, set to max allowed
      autoEndDate = maxAllowedEndDate;
    } // Set the date range with auto-calculated end date


    setRange({
      from: selectedDate,
      to: autoEndDate
    });
    setShowToast(false); // Update URL history

    (0,utils/* replaceHistory */.df)("startDate", (0,static_utils/* convertDateToUnix */.cJ)(selectedDate).toString());
    (0,utils/* replaceHistory */.df)("endDate", (0,static_utils/* convertDateToUnix */.cJ)(autoEndDate).toString()); // Track analytics

    analytics?.trackLandingEvents({
      actionType: "travel_date_selected",
      payload: {
        departure: selectedDate?.toLocaleDateString("en-GB")?.replace(/\//gi, ":"),
        arrival: autoEndDate?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || ""
      }
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "travel_date_selected"
      }
    }, {
      fromDateTime: (0,static_utils/* convertDateToUnix */.cJ)(selectedDate),
      toDateTime: (0,static_utils/* convertDateToUnix */.cJ)(autoEndDate)
    }); // Auto-close calendar and move to next step

    setFocusedIndex(1); // Move to next widget (travellers)

    setDateTab(0); // Reset to start date tab for next time
  };

  const handleSubmit = (chkIn, chkOut) => {
    chkIn && setStartDate(chkIn);
    chkOut && setEndDate(chkOut);
    analytics?.trackLandingEvents({
      actionType: "travel_date_selected",
      payload: {
        departure: chkIn?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || "",
        arrival: chkOut?.toLocaleDateString("en-GB")?.replace(/\//gi, ":") || ""
      }
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "travel_date_selected"
      }
    }, {
      fromDateTime: chkIn ? (0,static_utils/* convertDateToUnix */.cJ)(chkIn) : 0,
      toDateTime: chkOut ? (0,static_utils/* convertDateToUnix */.cJ)(chkOut) : 0
    });
    setFocusedIndex(-1);
    setShowToast(false);
  };

  const isSingleDate = selectedSegment?.calenderSelectionType === "SINGLE";
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellingToWidget_style/* TravellingToWidgetStyle */.bF, {
    ref: device == "lg" ? ref : null,
    "data-test-id": "TravellingToWidget-TravellingToWidgetStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravelDateWiget, {
      ref: divRefs.current[0],
      showTravDate: focusedIndex == 0,
      handleTravDate: () => handleClick(0),
      travDateTitle: travDateTitle,
      startDate: range?.from,
      endDate: range?.to,
      "data-test-id": "TravellingToWidget-TravelDateWiget"
    }), travellerBookingFor ? /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellerBookingForWidget, {
      travellerBookingFor: travellerBookingFor,
      captureCount: captureCount,
      travCounterTitle: travCounterTitle,
      setCaptureCount: setCaptureCount,
      "data-test-id": "TravellingToWidget-TravellerBookingForWidget"
    }) : travellerInfoSection ? /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellerCounterWigetV2, {
      countValue: countValue,
      showSelectSection: focusedIndex === 3,
      handleSelectSection: () => handleClick(3),
      travSelectTitle: travellerInfoSection?.selectTitle,
      postSelectTitle: travellerInfoSection?.postSelectTitle,
      postSelectDesc: travellerInfoSection?.postSelectDesc,
      travCountTitle: travellerInfoSection?.title,
      description: travellerInfoSection?.description,
      isAgeRangeSelected: isAgeRangeSelected,
      travAgeRange: travAgeRange,
      "data-test-id": "TravellingToWidget-TravellerCounterWigetV2"
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravellerCounterWiget // ref={divRefs.current[1]}
    // showTravCount={focusedIndex == 1}
    , {
      captureCount: captureCount,
      maxTravAllowed: maxTravAllowed,
      minTravAllowed: minTravAllowed,
      travCountTitle: travCountTitle,
      handleCaptureCountIncr: handleCaptureCountIncr,
      handleCaptureCountDecr: handleCaptureCountDecr,
      travCountSubtitle: travCountSubtitle,
      "data-test-id": "TravellingToWidget-TravellerCounterWiget"
    }), focusedIndex == 0 && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_DatePickerComp, {
      startDateLabel: "Start Date",
      endDateLabel: "End Date",
      handleDayClick: handleDayClick,
      dateTab: dateTab,
      selected: range,
      from: range?.from,
      to: range?.to,
      maxEndDate: maxEndDate,
      minStartDate: minStartDate,
      toastMessage: toastMessage,
      showToast: showToast,
      isSingleDate: isSingleDate,
      calenderHeader: selectedSegment?.calenderHeader,
      onSingleDateSelect: handleSingleDateSelect,
      "data-test-id": "TravellingToWidget-DatePickerComp"
    }), focusedIndex == 0 && device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(ReactPortalComp/* default */.Z, {
      "data-test-id": "TravellingToWidget-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_RangeDatePicker, {
        calendarFooter: true,
        calendarHeader: true,
        onBackPress: () => handleClick(0),
        onSubmitButtonPress: handleSubmit,
        range: true,
        calenderRef: calenderRef,
        from: range?.from,
        to: range?.to,
        toastMessage: toastMessage,
        showToast: showToast,
        selected: range,
        handleDayClick: handleDayClick,
        maxEndDate: maxEndDate,
        minStartDate: minStartDate,
        isSingleDate: isSingleDate,
        bottomBarDescription: selectedSegment?.config?.bottomBarDescription,
        bottomBarIcon: selectedSegment?.config?.bottomBarIcon,
        onSingleDateSelect: handleSingleDateSelect,
        "data-test-id": "TravellingToWidget-RangeDatePicker"
      })
    }), focusedIndex === 3 && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravAgeRangenCountPicker, {
      ageRangeSelectRef: ageRangeSelectRef,
      travellerInfoSelectSection: travellerInfoSection?.travellerInfoSelectSection,
      captureCount: captureCount,
      setTravAgeRange: setTravAgeRange,
      setCaptureCount: setCaptureCount,
      setIsAgeRangeSelectedError: setIsAgeRangeSelectedError,
      focusedIndex: focusedIndex,
      travAgeRange: travAgeRange ?? [],
      ageRangeSelectIndex: ageRangeSelectIndex,
      setAgeRangeSelectIndex: setAgeRangeSelectIndex,
      setFocusedIndex: setFocusedIndex,
      travellingToRef: travellingToRef,
      "data-test-id": "TravellingToWidget-TravAgeRangenCountPicker"
    }), focusedIndex === 3 && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(ReactPortalComp/* default */.Z, {
      "data-test-id": "TravellingToWidget-ReactPortalComp",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TravellingToWidget_TravAgeRangenCountPicker, {
        ageRangeSelectRef: ageRangeSelectRef,
        travellerInfoSelectSection: travellerInfoSection?.travellerInfoSelectSection,
        captureCount: captureCount,
        setTravAgeRange: setTravAgeRange,
        setIsAgeRangeSelectedError: setIsAgeRangeSelectedError,
        setCaptureCount: setCaptureCount,
        focusedIndex: focusedIndex,
        travAgeRange: travAgeRange ?? [],
        ageRangeSelectIndex: ageRangeSelectIndex,
        setAgeRangeSelectIndex: setAgeRangeSelectIndex,
        setFocusedIndex: setFocusedIndex,
        "data-test-id": "TravellingToWidget-TravAgeRangenCountPicker"
      })
    }), dateChangeToastMessage && showDateChangeToast && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
      type: "warning",
      iconUrl: selectedSegment?.toast?.iconUrl,
      toastTxt: dateChangeToastMessage,
      position: "fixed",
      toastTxtMargin: "0px 0px 0px 5px",
      color: Global/* theme.yellowText */.rS.yellowText,
      fontSize: "14px",
      fontWeight: "700",
      right: "50px",
      bottom: device === "sm" ? "70px" : "50px",
      "data-test-id": "TravellingToWidget-WebToast"
    })]
  });
};

/* harmony default export */ const TravellingToWidget_TravellingToWidget = (TravellingToWidget);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 3 modules
var navigation = __webpack_require__(91908);
// EXTERNAL MODULE: ../../libs/ui/src/lib/contexts/index.ts + 1 modules
var contexts = __webpack_require__(40752);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/EducationModal/EducationModal.tsx + 1 modules
var EducationModal = __webpack_require__(9840);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelProtectionV2/TravelProtectionV2.style.ts


const bounce = (0,styled_components_browser_esm/* keyframes */.F4)(["0%,20%,50%,80%,100%{transform:translateY(0);}40%{transform:translateY(-8px);}60%{transform:translateY(-4px);}"]);
const TravelProtectionV2Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__TravelProtectionV2Wrapper",
  componentId: "sc-8nlmmk-0"
})(["width:1200px;border-radius:40px;background-color:#ffffff;margin:0 auto;align-items:center;position:relative;"]);
const DiscoveryBarSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__DiscoveryBarSection",
  componentId: "sc-8nlmmk-1"
})(["width:100%;background:transparent;display:flex;align-items:center;justify-content:center;gap:16px;position:absolute;top:-55px;animation:", " 1s 5;transition:all 0.3s ease;&:hover{animation-play-state:paused;transform:translateY(-2px);}&::before{content:\"\";width:16px;height:24px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='32' viewBox='0 0 24 32' fill='none'%3E%3Cpolyline points='6 4 12 10 18 4' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpolyline points='6 14 12 20 18 14' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");background-size:contain;background-repeat:no-repeat;flex-shrink:0;margin-top:10px;}&::after{content:\"\";width:16px;height:24px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='32' viewBox='0 0 24 32' fill='none'%3E%3Cpolyline points='6 4 12 10 18 4' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpolyline points='6 14 12 20 18 14' stroke='white' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");background-size:contain;background-repeat:no-repeat;flex-shrink:0;margin-top:10px;}& > *{color:", ";font-weight:700;font-size:13px;text-align:center;}"], bounce, Global/* theme.whiteText */.rS.whiteText);
const SectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__SectionTitle",
  componentId: "sc-8nlmmk-2"
})(["font-size:18px;font-weight:900;background:linear-gradient(90deg,#ddf4ff 0%,#c2dfff 103.59%);color:#0e5b99;padding:18px 0px;width:286px;display:flex;align-items:flex-start;justify-content:right;position:relative;border-radius:40px 0 0 40px;&::before{content:\"\";position:absolute;right:-20px;top:-2px;width:0;height:0;border-style:solid;border-width:34px 0 34px 13px;border-color:transparent transparent transparent #e0efff;}&::after{content:\"\";position:absolute;right:-13px;top:-2px;width:0;height:0;border-style:solid;border-width:34px 0 34px 13px;border-color:transparent transparent transparent #c2dfff;}"]);
const SectionIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TravelProtectionV2style__SectionIcon",
  componentId: "sc-8nlmmk-3"
})(["width:15px;height:15px;object-fit:contain;"]);
const PlanCards = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__PlanCards",
  componentId: "sc-8nlmmk-4"
})(["display:flex;gap:12px;width:100%;margin-left:10px;"]);
const PlanCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__PlanCard",
  componentId: "sc-8nlmmk-5"
})(["display:flex;gap:8px;align-items:center;background:transparent;cursor:pointer;transition:all 0.3s ease;padding:11px 16px;box-sizing:border-box;"]);
const PlanIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__PlanIconWrapper",
  componentId: "sc-8nlmmk-6"
})(["display:flex;align-items:center;justify-content:center;width:56px;height:56px;flex-shrink:0;margin-right:16px;"]);
const PlanIconV2 = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TravelProtectionV2style__PlanIconV2",
  componentId: "sc-8nlmmk-7"
})(["width:32px;height:32px;object-fit:contain;"]);
const PlanContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__PlanContent",
  componentId: "sc-8nlmmk-8"
})(["flex:1;display:flex;flex-direction:column;gap:4px;min-width:0;"]);
const PlanTitleRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__PlanTitleRow",
  componentId: "sc-8nlmmk-9"
})(["display:flex;align-items:center;gap:8px;flex-wrap:wrap;"]);
const PlanTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__PlanTitleContainer",
  componentId: "sc-8nlmmk-10"
})(["font-size:14px;font-weight:700;color:#000000;line-height:100%;display:flex;align-items:center;"]);
const NewTag = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TravelProtectionV2style__NewTag",
  componentId: "sc-8nlmmk-11"
})(["height:14px;width:auto;object-fit:contain;"]);
const PlanDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__PlanDetails",
  componentId: "sc-8nlmmk-12"
})(["font-size:12px;color:#4a4a4a;line-height:100%;display:flex;flex-direction:column;gap:2px;"]);
const ArrowIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__ArrowIcon",
  componentId: "sc-8nlmmk-13"
})(["display:flex;align-items:center;justify-content:center;width:18px;height:18px;flex-shrink:0;margin-left:16px;svg{width:24px;height:24px;}"]);
const TagImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TravelProtectionV2style__TagImage",
  componentId: "sc-8nlmmk-14"
})(["height:14px;object-fit:contain;"]);
const TagContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__TagContainer",
  componentId: "sc-8nlmmk-15"
})(["margin-left:8px;display:flex;align-items:center;"]);
const ChevStateWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__ChevStateWrap",
  componentId: "sc-8nlmmk-16"
})(["border-radius:22px;padding:2px;background:#eaf5ff;transform:rotate(-90deg);svg{width:10px;height:10px;}"]);
const PlanSeparator = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionV2style__PlanSeparator",
  componentId: "sc-8nlmmk-17"
})(["width:1px;height:100%;background:#e0e0e0;align-self:center;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelProtectionV2/TravelProtectionV2.tsx















const TravelProtectionV2 = ({
  title,
  icon,
  plans,
  discoveryText
}) => {
  if (!title || !plans) return null;
  const {
    setType
  } = (0,contexts/* usePlanType */.U)();
  const {
    0: activePlan,
    1: setActivePlan
  } = (0,react.useState)(plans[0] || null);
  const {
    0: currentPageIndex,
    1: setCurrentPageIndex
  } = (0,react.useState)(0);
  const {
    0: showModal,
    1: setShowModal
  } = (0,react.useState)(false);
  const analytics = (0,insurance/* getAnalytics */.I)();
  const hasTracked = (0,react.useRef)(false); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "travel_protection_v2_seen"
      });
    }

    hasTracked.current = true;
  }, []);
  const {
    ref: travelProtectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  }); // Education modal tracking handlers

  const handleEducationModalShown = () => {
    analytics?.trackLandingEvents?.({
      actionType: "educationModal_shown"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_shown"
      }
    });
  };

  const handleEducationModalNextClick = () => {
    analytics?.trackLandingEvents?.({
      actionType: "educationModal_next_click"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_next_click"
      }
    });
  };

  const handleEducationModalSkipClick = () => {
    analytics?.trackLandingEvents?.({
      actionType: "educationModal_skip_click"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_skip_click"
      }
    });
  };

  const handleEducationModalPageShown = pageId => {
    analytics?.trackLandingEvents?.({
      actionType: `educationModal_${pageId}_shown`
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `educationModal_${pageId}_shown`
      }
    });
  };

  const handleEducationSkip = () => {
    setShowModal(false);
    setType(activePlan?.type);
    navigation/* navigationActions.navigateToLanding */.ej.navigateToLanding({
      type: activePlan?.type
    }, false);
  };

  const handlePlanClick = plan => {
    analytics?.trackCommonLandingEvents({
      actionType: `protection_plan_${plan.type}_clicked`
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `protection_plan_${plan.type}_clicked`
      }
    });
    (0,XDMAnalytics.triggerPageExit)();

    if (plan.showPages) {
      setActivePlan(plan);
      setCurrentPageIndex(0);
      setShowModal(true);
    } else {
      setType(plan.type);
      navigation/* navigationActions.navigateToLanding */.ej.navigateToLanding({
        type: plan?.type
      }, false);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TravelProtectionV2Wrapper, {
      ref: travelProtectionRef,
      "data-test-id": "TravelProtectionV2-TravelProtectionV2Wrapper",
      children: [discoveryText && /*#__PURE__*/(0,jsx_runtime.jsx)(DiscoveryBarSection, {
        "data-test-id": "TravelProtectionV2-DiscoveryBarSection",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: discoveryText,
          "data-test-id": "TravelProtectionV2-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FlexComp/* default */.Z, {
        "data-test-id": "TravelProtectionV2-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionTitle, {
          "data-test-id": "TravelProtectionV2-SectionTitle",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: title,
            "data-test-id": "TravelProtectionV2-FormattedText"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionIcon, {
            src: icon,
            alt: "travelProtection",
            "data-test-id": "TravelProtectionV2-SectionIcon"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PlanCards, {
          "data-test-id": "TravelProtectionV2-PlanCards",
          children: plans.map((plan, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PlanCard, {
              onClick: () => handlePlanClick(plan),
              "data-test-id": "TravelProtectionV2-PlanCard",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PlanIconV2, {
                src: plan.icon,
                alt: "plan icon",
                "data-test-id": "TravelProtectionV2-PlanIconV2"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PlanDetails, {
                "data-test-id": "TravelProtectionV2-PlanDetails",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PlanTitleContainer, {
                  "data-test-id": "TravelProtectionV2-PlanTitleContainer",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                    value: plan.title,
                    "data-test-id": "TravelProtectionV2-FormattedText"
                  }), plan.tagURL && /*#__PURE__*/(0,jsx_runtime.jsx)(TagContainer, {
                    "data-test-id": "TravelProtectionV2-TagContainer",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagImage, {
                      src: plan.tagURL,
                      alt: "New",
                      "data-test-id": "TravelProtectionV2-TagImage"
                    })
                  })]
                }), plan.info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
                  value: plan.info,
                  baseStyle: {
                    fontSize: "12px",
                    color: "#4a4a4a"
                  },
                  "data-test-id": "TravelProtectionV2-FormattedText"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChevStateWrap, {
                "data-test-id": "TravelProtectionV2-ChevStateWrap",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* BlueChev */.a, {
                  "data-test-id": "TravelProtectionV2-BlueChev"
                })
              })]
            }, plan.type), index < plans.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(PlanSeparator, {
              "data-test-id": "TravelProtectionV2-PlanSeparator"
            })]
          }))
        })]
      })]
    }), showModal && activePlan && activePlan.showPages && /*#__PURE__*/(0,jsx_runtime.jsx)(EducationModal/* default */.Z, {
      pagesData: activePlan.pages,
      knowMore: activePlan.knowMore,
      setShowEducationModal: setShowModal,
      skipButtonHandler: handleEducationSkip,
      onModalShown: handleEducationModalShown,
      onNextClick: handleEducationModalNextClick,
      onSkipClick: handleEducationModalSkipClick,
      onPageShown: handleEducationModalPageShown,
      "data-test-id": "TravelProtectionV2-EducationModal"
    })]
  });
};

/* harmony default export */ const TravelProtectionV2_TravelProtectionV2 = (TravelProtectionV2);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/WhatsCovered/WhatsCovered.tsx + 1 modules
var WhatsCovered = __webpack_require__(2450);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/WhyBuyTravIns/WhyBuyTravIns.tsx + 1 modules
var WhyBuyTravIns = __webpack_require__(62107);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/index.tsx































































































































 // export { default as LandingFaq } from "./LandingFaq/LandingFaq";








/***/ })

}]);